// ═══════════════════════════════════════════════════════════════════════════
// PedResus Search Index — Complete Rewrite
// One entry per specific item per tab. drugId/itemId enables auto-expand.
// ═══════════════════════════════════════════════════════════════════════════

export const SEARCH_INDEX = [

  // ─── CALCULATOR ────────────────────────────────────────────────────────────
  {
    id: "calc-weight", tab: "calculator", tabLabel: "Calculator",
    section: "Weight", label: "Weight Calculator",
    keywords: ["weight", "kg", "estimate", "broselow", "length", "age"],
    description: "Calculate or estimate patient weight by age, length, or Broselow tape",
  },

  // ─── EQUIPMENT ─────────────────────────────────────────────────────────────
  {
    id: "eq-ett", tab: "equipment", tabLabel: "Equipments",
    section: "Reference Table", label: "ETT Size & Depth",
    keywords: ["ett", "endotracheal tube", "intubation", "uncuffed", "cuffed", "oral", "nasal", "age formula", "size"],
    description: "ETT uncuffed: (age÷4)+4 · Cuffed: (age÷4)+3.5 · Depth: (age÷2)+12 cm oral",
  },
  {
    id: "eq-suction", tab: "equipment", tabLabel: "Equipments",
    section: "Reference Table", label: "Suction Catheter Size",
    keywords: ["suction", "french", "catheter", "airway suction"],
    description: "Suction catheter French size by weight and age",
  },
  {
    id: "eq-lma", tab: "equipment", tabLabel: "Equipments",
    section: "Reference Table", label: "LMA Size",
    keywords: ["lma", "laryngeal mask", "supraglottic", "airway"],
    description: "LMA size by weight — 1 (<5kg), 1.5 (5–10kg), 2 (10–20kg), 2.5 (20–30kg)",
  },
  {
    id: "eq-defib", tab: "equipment", tabLabel: "Equipments",
    section: "Reference Table", label: "Defibrillation & Cardioversion",
    keywords: ["defibrillation", "cardioversion", "joules", "shock", "vf", "vt", "aed", "4 j/kg"],
    description: "Defibrillation 4 J/kg (max 10 J/kg) · Cardioversion 0.5–1 J/kg",
  },
  {
    id: "eq-ngt", tab: "equipment", tabLabel: "Equipments",
    section: "Reference Table", label: "NGT Size",
    keywords: ["ngt", "nasogastric", "tube", "feeding tube", "french"],
    description: "NGT French size by weight/age",
  },
  {
    id: "eq-iv-gauge", tab: "equipment", tabLabel: "Equipments",
    section: "Reference Table", label: "IV Access — Cannula Gauge",
    keywords: ["iv", "cannula", "gauge", "access", "venflon", "intravenous"],
    description: "IV cannula gauge by age — neonate 24G, infant 22–24G, child 20–22G",
  },
  {
    id: "eq-difficult-airway", tab: "equipment", tabLabel: "Equipments",
    section: "Difficult Airway", label: "Difficult Airway Prediction (LEMON / MOANS / RODS)",
    keywords: ["difficult airway", "lemon", "moans", "rods", "mallampati", "micrognathia", "pierre robin", "treacher collins", "predict"],
    description: "AIDAA 2022 — structural and acquired difficult airway predictors",
  },
  {
    id: "eq-vortex", tab: "equipment", tabLabel: "Equipments",
    section: "Difficult Airway", label: "Vortex Approach — CICO / Neck Rescue",
    keywords: ["vortex", "cico", "cannot intubate", "cannot oxygenate", "neck rescue", "efona", "cricothyrotomy", "surgical airway"],
    description: "3 lifelines: Face Mask → SGA → ETT → Neck Rescue (eFONA)",
  },
  {
    id: "eq-fob", tab: "equipment", tabLabel: "Equipments",
    section: "Difficult Airway", label: "Fibreoptic Bronchoscope Sizing",
    keywords: ["fibreoptic", "fob", "bronchoscope", "awake intubation", "scope size"],
    description: "Scope OD by weight: <3 kg 2.2 mm → adolescent 4.9 mm",
  },
  {
    id: "eq-bvm", tab: "equipment", tabLabel: "Equipments",
    section: "Monitoring", label: "BVM Technique",
    keywords: ["bvm", "bag mask", "bag valve", "ec clamp", "jaw thrust", "two person", "opa", "npa"],
    description: "EC technique, 2-person preferred, OPA/NPA sizing, tidal volume 6–8 mL/kg",
  },
  {
    id: "eq-spo2", tab: "equipment", tabLabel: "Equipments",
    section: "Monitoring", label: "Pulse Oximetry — Limitations & SpO₂ Targets",
    keywords: ["spo2", "pulse oximetry", "saturation", "co poisoning", "methhaemoglobin", "preductal", "postductal", "pphn"],
    description: "SpO₂ targets, probe sites, COHb false normal, MetHb reads ~85%",
  },
  {
    id: "eq-bp", tab: "equipment", tabLabel: "Equipments",
    section: "Monitoring", label: "Blood Pressure Cuff Selection",
    keywords: ["blood pressure", "bp cuff", "nibp", "cuff size", "falsely high", "falsely low"],
    description: "Cuff width = 40% arm circumference. Too small → falsely HIGH",
  },
  {
  id: "eq-io-overview",
  tab: "equipment", tabLabel: "Equipment",
  section: "IO Access",
  label: "IO Access — Sites, Indications & Contraindications",
  keywords: [
    "io", "intraosseous", "io access", "io sites", "proximal tibia",
    "distal tibia", "distal femur", "proximal humerus", "io contraindications",
    "bone disease", "osteogenesis imperfecta", "compartment syndrome",
    "pals io", "2 attempts 90 seconds", "second line iv",
  ],
  description:
    "AHA PALS 2020: IO if IV fails after 2 attempts or 90 s. Sites: proximal tibia (first choice), distal tibia, distal femur, proximal humerus. Contraindications: fracture, previous IO same bone <24 hr, bone disease, infection over site.",
},
{
  id: "eq-io-ezio",
  tab: "equipment", tabLabel: "Equipment",
  section: "IO Access",
  label: "EZ-IO Powered Drill — Step-by-Step & Needle Selection",
  keywords: [
    "ez-io", "ezio", "powered drill", "io drill", "vidacare",
    "pink needle", "blue needle", "yellow needle", "15g 15mm", "15g 25mm",
    "io needle selection", "io insertion technique", "marrow aspirate",
    "io flush", "lignocaine io", "ez stabiliser", "io confirmation",
  ],
  description:
    "Pink 15G/15mm (3–39 kg) · Blue 15G/25mm (≥40 kg). Drill at 90°, stop at loss of resistance. Flush 5–10 mL NaCl; lignocaine 0.5 mg/kg IO before flush in conscious patient.",
},
{
  id: "eq-io-manual",
  tab: "equipment", tabLabel: "Equipment",
  section: "IO Access",
  label: "Manual IO — Jamshidi / Cook Needle Technique",
  keywords: [
    "manual io", "jamshidi", "cook needle", "io manual insertion",
    "butterfly needle neonate", "16g io", "14g io", "rotation technique",
    "io without drill", "io no equipment",
  ],
  description:
    "16G for <18 mo · 14G for older children. Insert at 90° with firm rotating motion — do NOT rock. Loss of resistance = cortex entered. Aspirate marrow, flush 5 mL NaCl.",
},
{
  id: "eq-io-sternal",
  tab: "equipment", tabLabel: "Equipment",
  section: "IO Access",
  label: "Sternal IO — FAST-1 Device (Adults / ≥12 yr Only)",
  keywords: [
    "sternal io", "fast-1", "fast1", "manubrium io",
    "sternal intraosseous", "angle of louis", "not paediatric",
    "military io", "prehospital io", "io adults",
  ],
  description:
    "FAST-1 device only. NOT recommended <12 yr — thin sternum, growth plates, proximity to heart. Landmark: midline manubrium at angle of Louis. Gravity flow ~150 mL/hr.",
},
{
  id: "eq-io-confirm",
  tab: "equipment", tabLabel: "Equipment",
  section: "IO Access",
  label: "IO Confirmation, Complications & Lab Samples",
  keywords: [
    "io confirmation", "io malposition", "io extravasation",
    "io compartment syndrome", "io osteomyelitis", "io fat embolism",
    "growth plate io", "io lab samples", "marrow blood gas",
    "io blood culture", "io complications", "io needle dislodgement",
  ],
  description:
    "Confirm: needle stands unsupported, marrow aspirate, flushes freely. Remove if: rocking needle, swelling, resistance. Complications: extravasation, osteomyelitis (0.6%), growth plate injury. IO aspirate: acceptable for U&E, glucose, blood gas, cross-match, cultures.",
},
{
  id: "eq-io-difficult-iv",
  tab: "equipment", tabLabel: "Equipment",
  section: "IO Access",
  label: "Difficult IV Access Hierarchy — IO → USS-IV → EJV → CVC → UVC → Cut-down",
  keywords: [
    "difficult iv access", "difficult iv", "iv access hierarchy",
    "ultrasound iv", "external jugular", "ejv", "central venous catheter",
    "cvc paediatric", "femoral vein", "umbilical venous catheter", "uvc",
    "venous cutdown", "saphenous cutdown", "long saphenous",
    "seldinger technique", "io vs cvc",
  ],
  description:
    "Hierarchy: IO (cardiac arrest/collapse, after 2 IV fails) → USS-guided peripheral IV → EJV → CVC (USS-guided, femoral first) → UVC (neonates ≤7 days) → saphenous cut-down (last resort). CVC sizes: 4Fr neonate, 5Fr child, 7Fr adolescent.",
},
 
// ─── DIFFICULT AIRWAY — entries missing from current index ───────────────────
{
  id: "eq-video-laryngoscopy",
  tab: "equipment", tabLabel: "Equipment",
  section: "Difficult Airway",
  label: "Video Laryngoscopy — C-MAC / GlideScope",
  keywords: [
    "video laryngoscopy", "vl", "c-mac", "cmac", "glidescope",
    "hyperangulated blade", "indirect laryngoscopy", "difficult intubation",
    "stylet 60 degrees", "improved cormack lehane", "vl technique",
    "max 3 attempts", "d blade",
  ],
  description:
    "First-line for anticipated difficult airway ≥10 kg. Improves C-L grade by 1–2. Do NOT align axes — angle blade, look at screen. Stylet 60–90° for GlideScope. Max 3 total attempts.",
},
{
  id: "eq-bougie",
  tab: "equipment", tabLabel: "Equipment",
  section: "Difficult Airway",
  label: "Bougie & Airway Exchange Catheter (AEC)",
  keywords: [
    "bougie", "gum elastic bougie", "airway exchange catheter", "aec",
    "eschmann", "frova", "5fr bougie", "railroad ett",
    "tracheal rings", "limited view intubation", "difficult intubation aid",
    "o2 insufflation aec", "barotrauma aec",
  ],
  description:
    "Paeds bougie: 5 Fr Eschmann/Frova for <10 yr. Advance until tracheal rings felt → railroad ETT. AEC: 11 Fr for ETT ≥5 mm · 8 Fr for 3.5–5 mm. O₂ via AEC: 1 L/min only — barotrauma risk.",
},
{
  id: "eq-laryngoscope-blade",
  tab: "equipment", tabLabel: "Equipment",
  section: "Reference Table",
  label: "Laryngoscope Blade Selection by Age",
  keywords: [
    "laryngoscope blade", "blade size", "miller blade", "macintosh blade",
    "straight blade", "curved blade", "size 0 blade", "size 1 blade",
    "size 2 blade", "size 3 blade", "neonatal blade", "infant blade",
    "blade selection age", "direct laryngoscopy",
  ],
  description:
    "Neonate/infant: Miller 0–1 (straight). Toddler: Miller 1 or Mac 2. Child: Mac 2. Adolescent: Mac 3. Straight blade lifts epiglottis directly — preferred <2 yr.",
},
{
  id: "eq-suction-technique",
  tab: "equipment", tabLabel: "Equipment",
  section: "Reference Table",
  label: "Suction — Catheter Size, Pressure & Technique",
  keywords: [
    "suction", "suction catheter", "suction pressure", "suction technique",
    "yankauer", "flexible suction", "suction neonate", "deep suction",
    "suction pressure mmhg", "3 x ett", "suction french",
    "suction complication", "vagal bradycardia suction",
  ],
  description:
    "Catheter Fr ≈ 3 × ETT mm. Pressure: neonate 60–80 mmHg · infant/child 80–100 mmHg · max 120 mmHg. Pre-oxygenate. Each pass ≤10 s. Vagal bradycardia risk in neonates.",
},
{
  id: "eq-glycopyrrolate-fob",
  tab: "equipment", tabLabel: "Equipment",
  section: "Difficult Airway",
  label: "Glycopyrrolate — Anti-sialagogue for FOB / Awake Intubation",
  keywords: [
    "glycopyrrolate", "anti sialagogue", "antisialagogue", "fob premedication",
    "awake intubation premedication", "dry secretions", "0.01 mg/kg",
    "robinul", "before fibreoptic", "before bronchoscopy",
  ],
  description:
    "0.01 mg/kg IM/IV 30 min before FOB or awake intubation. Dries secretions, improves visualisation. Does not cross BBB — no CNS effects. Max 0.4 mg.",
},
{
  id: "eq-igel-lma-supreme",
  tab: "equipment", tabLabel: "Equipment",
  section: "Difficult Airway",
  label: "iGel / LMA Supreme — 2nd Gen SGA Sizing & Insertion",
  keywords: [
    "igel", "lma supreme", "second generation sga", "supraglottic airway",
    "2nd gen lma", "gastric drain port", "sga sizing", "lma insertion",
    "lma cuff", "sga difficult airway", "igel size", "igel insertion",
    "sga ventilation", "aspirate via sga",
  ],
  description:
    "Sizes: <5 kg=1 · 5–10 kg=1.5 · 10–20 kg=2 · 20–30 kg=2.5 · 30–50 kg=3 · >50 kg=4. iGel: no cuff, gastric drain port, high seal. Lubricate caudal surface, advance along hard palate. Max 2 attempts per operator.",
},
{
  id: "eq-cricothyrotomy",
  tab: "equipment", tabLabel: "Equipment",
  section: "Difficult Airway",
  label: "Cricothyrotomy / Cannula CICO — eFONA Technique",
  keywords: [
    "cricothyrotomy", "efona", "cico", "cannot intubate cannot oxygenate",
    "surgical airway", "scalpel finger tube", "ctm", "cricothyroid membrane",
    "cannula cricothyrotomy", "16g cannula jet", "jet ventilation",
    "neck rescue", "emergency airway", "tracheostomy emergency",
    "age 8 years", "under 8 airway",
  ],
  description:
    "≥8 yr: scalpel–finger–tube via CTM (5.0 cuffed ETT). <8 yr: CTM too small — 16G cannula + jet ventilation 1 s on/4 s off, 3–5 min bridge only (CO₂ rises). Call ENT/surgeons EARLY.",
},
{
  id: "eq-ett-confirmation",
  tab: "equipment", tabLabel: "Equipment",
  section: "Reference Table",
  label: "ETT Confirmation — Waveform ETCO₂ vs Colorimetric",
  keywords: [
    "ett confirmation", "endotracheal tube confirmation", "waveform etco2",
    "colorimetric co2", "chest rise", "misting", "oesophageal intubation",
    "right main bronchus", "bilateral breath sounds", "etco2 confirmation",
    "no waveform", "tube placement",
  ],
  description:
    "Gold standard: waveform ETCO₂ — 6 consistent waveforms confirm tracheal placement. Colorimetric alone NOT sufficient. Also: bilateral breath sounds, chest rise, misting, no epigastric gurgle. CXR to confirm depth.",
},
{
  id: "eq-cuffed-vs-uncuffed",
  tab: "equipment", tabLabel: "Equipment",
  section: "Reference Table",
  label: "Cuffed vs Uncuffed ETT — When to Use Each",
  keywords: [
    "cuffed ett", "uncuffed ett", "cuffed vs uncuffed", "cuff leak",
    "inflatable cuff", "microcuff", "cuffed 8kg", "subglottic stenosis risk",
    "cuff pressure", "20 cmh2o cuff", "high compliance low pressure cuff",
  ],
  description:
    "Cuffed preferred ≥8 kg (better seal, less repeated laryngoscopy, lower aspiration risk). Uncuffed: very small neonates, known subglottic pathology. Cuff pressure ≤20 cmH₂O. Microcuff has distal cuff placement.",
},
{
  id: "eq-nasal-intubation",
  tab: "equipment", tabLabel: "Equipment",
  section: "Reference Table",
  label: "Nasal Intubation — Depth Formula & Indications",
  keywords: [
    "nasal intubation", "nasotracheal", "nasal ett depth",
    "age 2 plus 15", "(age/2)+15", "nasal tube", "nasal airway",
    "oral vs nasal intubation", "prolonged intubation", "icu intubation",
  ],
  description:
    "Nasal ETT depth: (age÷2) + 15 cm at nares. Use 0.5 mm smaller ETT than oral. Preferred for prolonged intubation (better fixation). Contraindicated: skull base fracture, coagulopathy, nasal polyps.",
},
  // ─── VITALS ────────────────────────────────────────────────────────────────
  {
    id: "vitals-calculator", tab: "vitals", tabLabel: "Vitals",
    section: "Live Calculator", label: "Live Vitals Calculator — Normal vs Abnormal",
    keywords: ["vitals", "live calculator", "normal", "abnormal", "tachycardia", "bradycardia", "tachypnoea", "hypotension", "fever", "spo2"],
    description: "Enter HR, RR, BP, SpO₂, temp — auto-flags abnormal values by age band",
  },
  {
    id: "vitals-reference", tab: "vitals", tabLabel: "Vitals",
    section: "Quick Reference", label: "Normal Vital Signs by Age",
    keywords: ["normal vitals", "heart rate", "hr", "respiratory rate", "rr", "blood pressure", "sbp", "neonate", "infant", "toddler", "adolescent", "pals"],
    description: "Age-specific normal HR, RR, SBP ranges — PALS 2020",
  },
  {
    id: "vitals-ecg-vf", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "VF — Ventricular Fibrillation",
    keywords: ["vf", "ventricular fibrillation", "shockable", "defibrillation", "arrest", "chaotic"],
    description: "Chaotic irregular deflections — defibrillate 4 J/kg immediately",
  },
  {
    id: "vitals-ecg-vt", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "Pulseless VT",
    keywords: ["vt", "ventricular tachycardia", "pulseless vt", "pvt", "wide qrs", "shockable", "torsades"],
    description: "Wide bizarre QRS, no pulse — treat as VF. Torsades: MgSO₄",
  },
  {
    id: "vitals-ecg-asystole", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "Asystole",
    keywords: ["asystole", "flat line", "no activity", "cardiac arrest", "non shockable"],
    description: "Flat line — CPR + adrenaline 0.01 mg/kg. Do NOT defibrillate",
  },
  {
    id: "vitals-ecg-pea", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "PEA — Pulseless Electrical Activity",
    keywords: ["pea", "pulseless electrical activity", "organised", "no pulse", "4h4t", "reversible causes"],
    description: "Organised ECG — no palpable pulse. Find reversible cause (4H4T)",
  },
  {
    id: "vitals-ecg-svt", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "SVT — Supraventricular Tachycardia",
    keywords: ["svt", "supraventricular tachycardia", "adenosine", "narrow qrs", "vagal", "cardioversion", ">220 bpm"],
    description: "Infants >220 bpm — vagal → adenosine 0.1 mg/kg → cardioversion",
  },
  {
    id: "vitals-ecg-brady", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "Symptomatic Bradycardia",
    keywords: ["bradycardia", "slow heart rate", "atropine", "hr <60", "poor perfusion", "cpr"],
    description: "HR <60 + poor perfusion → O₂ first → atropine → CPR if no response",
  },
  {
    id: "vitals-ecg-wpw", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "WPW — Wolff-Parkinson-White",
    keywords: ["wpw", "wolff parkinson white", "pre excitation", "delta wave", "short pr", "ablation"],
    description: "Short PR + delta wave + wide QRS. Pre-excited AF → DC cardioversion",
  },
  {
    id: "vitals-ecg-chb", tab: "vitals", tabLabel: "Vitals",
    section: "ECG & Rhythms", label: "Complete Heart Block (3°)",
    keywords: ["complete heart block", "third degree", "chb", "av block", "pacing", "independent p waves"],
    description: "P waves and QRS completely independent — pacing required",
  },
  {
    id: "vitals-trending", tab: "vitals", tabLabel: "Vitals",
    section: "Vitals Trending", label: "Vitals Trending — Serial Monitoring",
    keywords: ["trending", "serial vitals", "chart", "csv", "record", "monitor", "trend"],
    description: "Record serial vitals, chart trends, export CSV with patient details",
  },

  // ─── RESUSCITATION ─────────────────────────────────────────────────────────
  {
    id: "resus-rsi", tab: "resuscitation", tabLabel: "Resuscitation",
    section: "RSI Quickstart", label: "RSI — Rapid Sequence Intubation",
    keywords: ["rsi", "rapid sequence intubation", "intubation", "ketamine", "rocuronium", "suxamethonium", "propofol", "7 ps"],
    description: "Weight-based RSI: induction + paralysis + pre-medication doses",
  },
  {
    id: "resus-infusions", tab: "resuscitation", tabLabel: "Resuscitation",
    section: "Infusions (mL/hr)", label: "Vasoactive Infusion Calculator",
    keywords: ["infusion", "dopamine", "noradrenaline", "adrenaline", "milrinone", "mL/hr", "mcg/kg/min", "vasopressor", "inotrope"],
    description: "mL/hr calculator for vasoactive infusions based on concentration and weight",
  },
  {
    id: "resus-rule6", tab: "resuscitation", tabLabel: "Resuscitation",
    section: "Rule of 6s", label: "Rule of 6s — Infusion Mixing",
    keywords: ["rule of 6", "rule of 6s", "infusion mixing", "concentration", "mcg/kg/min", "neonatal infusion"],
    description: "Rule of 6s for mixing weight-based infusions in neonates and small children",
  },
  {
    id: "resus-7ps", tab: "resuscitation", tabLabel: "Resuscitation",
    section: "7 Ps Checklist", label: "7 Ps RSI Checklist",
    keywords: ["7 ps", "rsi checklist", "preparation", "preoxygenation", "pretreatment", "paralysis", "positioning", "post intubation"],
    description: "Preparation · Preoxygenation · Pretreatment · Push the drugs · Paralysis · Position · Post-intubation",
  },
  {
    id: "resus-icd", tab: "resuscitation", tabLabel: "Resuscitation",
    section: "ICD Insertion", label: "ICD / Chest Tube Insertion",
    keywords: ["icd", "chest tube", "intercostal drain", "pneumothorax", "haemothorax", "blunt dissection", "french size"],
    description: "Indications, tube size by weight, technique, post-procedure care",
  },

  // ─── VENTILATOR ────────────────────────────────────────────────────────────
  {
    id: "vent-settings", tab: "ventilator", tabLabel: "Ventilator",
    section: "Settings", label: "Ventilator Settings — Weight-Based",
    keywords: ["ventilator", "tidal volume", "peep", "rate", "fio2", "pip", "ie ratio", "prvc", "simv", "pc ac", "vc ac"],
    description: "Vt 6–8 mL/kg, PEEP 5–8, FiO₂ titrate. Mode recommendations by condition",
  },
  {
    id: "vent-ards", tab: "ventilator", tabLabel: "Ventilator",
    section: "Settings", label: "ARDS — Lung Protective Strategy",
    keywords: ["ards", "lung protective", "low tidal volume", "permissive hypercapnia", "plateau pressure", "driving pressure", "peep ladder", "prone"],
    description: "Vt 4–6 mL/kg IBW · Plateau ≤30 · Driving pressure ≤15 · ARDSnet",
  },
  {
    id: "vent-troubleshoot", tab: "ventilator", tabLabel: "Ventilator",
    section: "Troubleshoot", label: "High PIP / Low Vt — DOPE Mnemonic",
    keywords: ["high pip", "high pressure", "dope", "displaced", "obstructed", "pneumothorax", "equipment failure", "auto peep", "alarm"],
    description: "DOPE: Displaced · Obstructed · Pneumothorax · Equipment failure",
  },
  {
    id: "vent-waveforms", tab: "ventilator", tabLabel: "Ventilator",
    section: "Waveforms", label: "Ventilator Waveforms",
    keywords: ["waveforms", "pressure scalar", "flow scalar", "inspiratory hold", "plateau pressure", "expiratory hold", "shark fin", "flow starvation"],
    description: "Live waveform simulator + library. Inspiratory/expiratory hold manoeuvres",
  },
  {
    id: "etco2", tab: "equipment", tabLabel: "Equipment",
    section: "Monitoring", label: "EtCO₂ / Capnography",
    keywords: ["etco2", "capnography", "end tidal co2", "rosc", "oesophageal intubation", "shark fin co2", "cpr monitoring"],
    description: "Normal capnogram phases, shark-fin pattern, oesophageal intubation, ROSC",
  },
  {
    id: "vent-weaning", tab: "ventilator", tabLabel: "Ventilator",
    section: "Weaning", label: "Weaning & Spontaneous Breathing Trial (SBT)",
    keywords: ["weaning", "extubation", "sbt", "spontaneous breathing trial", "cuff leak", "post extubation stridor", "hfnc", "niv"],
    description: "SBT: PS 5–8 + PEEP 5 for 30–120 min. Pre-extubation dexamethasone",
  },

  // ─── FLUIDS ────────────────────────────────────────────────────────────────
  {
    id: "fluids-maintenance", tab: "fluids", tabLabel: "Fluids",
    section: "Maintenance", label: "Maintenance Fluid — 4-2-1 Rule",
    keywords: ["maintenance", "4-2-1", "holliday segar", "daily fluid", "mL/hr", "fluid rate"],
    description: "4 mL/kg/hr for first 10 kg + 2 for next 10 + 1 for remainder",
  },
  {
    id: "fluids-bolus", tab: "fluids", tabLabel: "Fluids",
    section: "Maintenance", label: "Fluid Bolus — Resuscitation",
    keywords: ["bolus", "resuscitation", "20 mL/kg", "normal saline", "shock bolus", "fluid challenge"],
    description: "20 mL/kg isotonic crystalloid over 5–20 min. Up to 60 mL/kg first hour",
  },
  {
    id: "fluids-dka", tab: "fluids", tabLabel: "Fluids",
    section: "DKA", label: "DKA Fluid Protocol",
    keywords: ["dka", "diabetic ketoacidosis", "48 hours", "deficit", "cerebral oedema", "insulin infusion", "ispad"],
    description: "Deficit over 48 hr. Insulin 0.05–0.1 units/kg/hr after 1 hr fluids",
  },
  {
    id: "fluids-dehydration", tab: "fluids", tabLabel: "Fluids",
    section: "Diarrhoea", label: "Dehydration — ORT Plan A/B/C",
    keywords: ["dehydration", "ort", "oral rehydration", "ors", "plan a", "plan b", "plan c", "who imci", "diarrhoea"],
    description: "WHO/IAP: Plan B (ORS 100 mL/kg/4hr), Plan C (IV NS 20 mL/kg). Zinc mandatory",
  },
  {
    id: "fluids-burns", tab: "fluids", tabLabel: "Fluids",
    section: "Burns", label: "Parkland Formula — Burns Fluid",
    keywords: ["parkland", "burns", "tbsa", "lund browder", "lactated ringer", "burn fluid"],
    description: "3 mL/kg/%TBSA LR over 24 hr. Half in first 8 hr. UO target 1 mL/kg/hr",
  },
  {
    id: "fluids-shock", tab: "fluids", tabLabel: "Fluids",
    section: "Shock", label: "Shock Types & Management",
    keywords: ["shock", "hypovolaemic", "distributive", "cardiogenic", "obstructive", "septic", "vasopressor", "dobutamine"],
    description: "Fluid strategy and vasoactive drugs for all shock types",
  },
  {
    id: "fluids-periop", tab: "fluids", tabLabel: "Fluids",
    section: "Peri-op", label: "EBV / Allowable Blood Loss / NPO Deficit",
    keywords: ["ebv", "estimated blood volume", "allowable blood loss", "npo deficit", "transfusion", "pRBC", "perioperative"],
    description: "EBV by age-band, ABL formula, NPO deficit, pRBC trigger Hb <7",
  },

  // ─── ABG ───────────────────────────────────────────────────────────────────
  {
    id: "abg-interpreter", tab: "abg", tabLabel: "ABG",
    section: "Interpreter", label: "ABG Step-by-Step Interpretation",
    keywords: ["abg", "arterial blood gas", "ph", "paco2", "hco3", "bicarbonate", "acidosis", "alkalosis", "metabolic", "respiratory", "winters formula"],
    description: "pH → Primary disorder → Compensation → Anion gap → Delta-delta",
  },
  {
    id: "abg-anion-gap", tab: "abg", tabLabel: "ABG",
    section: "Anion Gap", label: "Anion Gap & MUDPILES",
    keywords: ["anion gap", "hagma", "nagma", "mudpiles", "methanol", "uraemia", "dka", "lactic acidosis", "salicylates"],
    description: "AG = Na − (Cl + HCO₃) · Normal 8–12. MUDPILES differential",
  },
  {
    id: "abg-oxygenation", tab: "abg", tabLabel: "ABG",
    section: "Oxygenation", label: "A-a Gradient & Oxygenation",
    keywords: ["a-a gradient", "alveolar arterial", "fio2", "pao2", "vq mismatch", "shunt", "hypoxaemia"],
    description: "A-a gradient = (FiO₂ × 713 − PaCO₂/0.8) − PaO₂. Normal <15 mmHg",
  },

  // ─── DRUGS — IV (one per drug) ─────────────────────────────────────────────
// ═══════════════════════════════════════════════════════════════════════════
// MISSING SEARCH INDEX ENTRIES
// Add these inside the SEARCH_INDEX array in searchIndex.js,
// after the existing "drug-dexamethasone-croup" entry and before the
// "─── ANTIHYPERTENSIVES ───" block (or append before the closing bracket).
// ═══════════════════════════════════════════════════════════════════════════

  // ─── RESUSCITATION — MISSING ───────────────────────────────────────────────
  {
    id: "drug-adrenaline-vol",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "adrenaline-vol",
    label: "Adrenaline 1:10,000 — Volume Calculation",
    keywords: ["adrenaline", "epinephrine", "1:10000", "0.1 mL/kg", "cardiac arrest", "volume"],
    description: "0.1 mL/kg of 1:10,000 solution IV/IO = 0.01 mg/kg. Repeat every 3–5 min",
  },
  {
    id: "drug-flumazenil",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "flumazenil",
    label: "Flumazenil — Benzodiazepine Reversal",
    keywords: ["flumazenil", "benzodiazepine reversal", "midazolam reversal", "0.01 mg/kg", "seizure risk", "anexate"],
    description: "0.01 mg/kg IV (max 0.2 mg). Caution: may precipitate seizures in benzo-dependent patients",
  },
  {
    id: "drug-diphenhydramine",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "diphenhydramine",
    label: "Diphenhydramine IV/IM — Anaphylaxis Adjunct / Dystonia",
    keywords: ["diphenhydramine", "benadryl", "phenargan", "anaphylaxis adjunct", "dystonic reaction", "1 mg/kg", "antihistamine iv"],
    description: "1 mg/kg IV/IM (max 50 mg). Adjunct in anaphylaxis — never replaces adrenaline. Also for acute dystonia",
  },
  {
    id: "drug-methylprednisolone",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "methylprednisolone",
    label: "Methylprednisolone IV — Severe Asthma / SCI / Allergy",
    keywords: ["methylprednisolone", "solu medrol", "depomedrol", "severe asthma", "spinal cord injury", "2 mg/kg", "steroid iv", "allergy"],
    description: "1–2 mg/kg/dose IV (max 60 mg). Spinal cord injury: 30 mg/kg load then 5.4 mg/kg/hr × 23 hr",
  },
  {
    id: "drug-naltrexone",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "naltrexone",
    label: "Naltrexone — Opioid Use Disorder (Not Acute OD)",
    keywords: ["naltrexone", "opioid use disorder", "alcohol dependence", "vivitrol", "not acute overdose", "use naloxone instead"],
    description: "NOT for acute opioid OD — use naloxone. Naltrexone is for opioid/alcohol use disorder maintenance",
  },
  {
    id: "drug-lidocaine-antiarrhythmic",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "lidocaine-antiarrhythmic",
    label: "Lidocaine IV — VT / VF (Alternative to Amiodarone)",
    keywords: ["lidocaine", "lignocaine", "antiarrhythmic", "vt", "vf", "ventricular tachycardia", "1 mg/kg", "class ib"],
    description: "1 mg/kg IV/IO bolus (max 100 mg). Infusion 20–50 mcg/kg/min. Alternative when amiodarone unavailable",
  },
  {
    id: "drug-vasopressin",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "vasopressin",
    label: "Vasopressin Infusion — Catecholamine-Resistant Shock",
    keywords: ["vasopressin", "adh", "catecholamine resistant shock", "v1 receptor", "0.0003 units/kg/min", "second line vasopressor"],
    description: "0.0003–0.002 units/kg/min IV. Second-line vasopressor in catecholamine-resistant shock",
  },
  {
  id: "drug-chlorpheniramine-iv",
  tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "chlorpheniramine-iv",
  label: "Chlorpheniramine (Avil) IV/IM — Allergic Reaction / Anaphylaxis Adjunct",
  keywords: ["chlorpheniramine", "avil", "iv", "im", "allergic reaction", "anaphylaxis adjunct",
             "urticaria", "drug reaction", "antihistamine iv", "0.1 mg/kg", "h1 blocker",
             "sedating antihistamine", "pheniramine"],
  description: "0.1 mg/kg IV slow/IM (max 10 mg). Avil ampoule 22.75 mg/mL. Adjunct only — never replaces adrenaline in anaphylaxis",
},

  // ─── ANTIARRHYTHMICS — MISSING ─────────────────────────────────────────────
  {
    id: "drug-sotalol-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "sotalol-iv",
    label: "Sotalol IV/PO — Ventricular Arrhythmias / SVT Prophylaxis",
    keywords: ["sotalol", "iv", "ventricular arrhythmia", "svt prophylaxis", "1 mg/kg", "beta blocker class iii", "qt prolongation", "torsades", "sotacor"],
    description: "1 mg/kg IV over 5 min (max 80 mg). PO: 2–8 mg/kg/day ÷ BD. Monitor QT — torsades risk",
  },

  // ─── PULMONARY HT — MISSING ────────────────────────────────────────────────
  {
    id: "drug-iloprost",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "iloprost-inh",
    label: "Iloprost Inhaled — Pulmonary Arterial Hypertension / iNO Weaning",
    keywords: ["iloprost", "ventavis", "prostacyclin", "inhaled", "pah", "pulmonary hypertension", "ino weaning", "prodose", "2.5 mcg"],
    description: "2.5–5 mcg/dose inhaled 6–9×/day via Prodose nebuliser. Prostacyclin analogue. Flushing, hypotension",
  },

  // ─── ENDOCRINE — MISSING ───────────────────────────────────────────────────
  {
    id: "drug-hydrocortisone-stress",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "hydrocortisone-stress",
    label: "Hydrocortisone Stress Dose — Adrenal Insufficiency / CAH Sick Day",
    keywords: ["hydrocortisone", "stress dose", "adrenal insufficiency", "cah", "congenital adrenal hyperplasia", "sick day rules", "50 mg/m2", "efcorlin", "solu cortef"],
    description: "Crisis: 50–100 mg/m² IV/IM stat (or 1–2 mg/kg). CAH sick day: triple oral dose; if vomiting give IM",
  },
  {
    id: "drug-fludrocortisone",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "fludrocortisone",
    label: "Fludrocortisone PO — Mineralocorticoid Replacement (CAH / Addison's)",
    keywords: ["fludrocortisone", "florinef", "mineralocorticoid", "cah", "primary adrenal insufficiency", "addisons", "0.05 mg", "0.1 mg", "salt wasting"],
    description: "0.05–0.2 mg/day PO OD. Neonates: 0.1–0.3 mg/day. Monitor BP, electrolytes, plasma renin",
  },
  {
    id: "drug-propranolol-thyroid",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "propranolol-thyroid",
    label: "Propranolol IV/PO — Thyroid Storm / SVT / Portal Hypertension",
    keywords: ["propranolol", "thyroid storm", "svt", "portal hypertension", "0.01 mg/kg", "inderal", "beta blocker", "adrenergic symptoms", "tachycardia"],
    description: "Thyroid storm IV: 0.01 mg/kg over 10 min (max 3 mg). PO: 0.5–2 mg/kg/day ÷ TDS. Give 1 hr after PTU",
  },
  {
    id: "drug-captopril",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "captopril-po",
    label: "Captopril PO — Hypertension / Heart Failure / Neonatal HTN",
    keywords: ["captopril", "capoten", "acten", "ace inhibitor", "hypertension", "heart failure", "neonatal hypertension", "0.1 mg/kg", "po"],
    description: "Start 0.1 mg/kg/dose TDS (max 6 mg/kg/day). Neonates: 0.01 mg/kg/dose TDS — extreme caution",
  },
  {
    id: "drug-amlodipine",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "amlodipine-iv",
    label: "Amlodipine PO — Chronic Hypertension (No IV Form)",
    keywords: ["amlodipine", "amlip", "stamlo", "amlopin", "calcium channel blocker", "hypertension", "0.1 mg/kg", "chronic", "no iv formulation"],
    description: "0.1–0.3 mg/kg/day PO OD (max 5 mg; up to 10 mg adolescents). No IV formulation. Not for acute emergency",
  },

  // ─── TOXICOLOGY — MISSING ──────────────────────────────────────────────────
  {
    id: "drug-physostigmine",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "physostigmine",
    label: "Physostigmine IV — Severe Anticholinergic Toxidrome",
    keywords: ["physostigmine", "anticholinergic toxidrome", "atropine overdose", "antihistamine overdose", "0.02 mg/kg", "crosses bbb", "contraindicated tca"],
    description: "0.02 mg/kg IV over 5 min (max 0.5 mg child). CONTRAINDICATED in TCA OD. Have atropine ready",
  },

  // ─── HAEMATOLOGY — MISSING ─────────────────────────────────────────────────
  {
    id: "drug-cryoprecipitate",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "cryoprecipitate",
    label: "Cryoprecipitate — Fibrinogen Deficiency / Haemophilia A / DIC",
    keywords: ["cryoprecipitate", "fibrinogen", "haemophilia a", "vwd", "dic", "hypofibrinogenaemia", "2 mL/kg", "fviii", "factor viii"],
    description: "1–2 mL/kg (1 unit per 5 kg) IV over 10–15 min. Target fibrinogen >100 mg/dL",
  },
  {
    id: "drug-protamine",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "protamine",
    label: "Protamine Sulfate — Heparin Reversal / Post-Cardiac Surgery",
    keywords: ["protamine", "heparin reversal", "post cardiac surgery", "lmwh overdose", "1 mg per 100 units", "anaphylaxis risk", "fish allergy"],
    description: "1 mg per 100 units UFH given in past 2 hr (max 50 mg) IV over 10 min. Anaphylaxis risk — have adrenaline ready",
  },
  {
    id: "drug-desmopressin-bleeding",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "desmopressin-bleeding",
    label: "Desmopressin (DDAVP) — Haemophilia A / Type 1 vWD / Platelet Dysfunction",
    keywords: ["desmopressin", "ddavp", "minirin", "haemophilia a", "vwd", "platelet dysfunction", "0.3 mcg/kg", "bleeding", "tachyphylaxis"],
    description: "0.3 mcg/kg IV over 30 min (max 20 mcg). Repeat q12–24h × 2–3 doses only (tachyphylaxis). Restrict fluids after dose",
  },
  {
    id: "drug-albumin-20",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "albumin-20",
    label: "Albumin 20% — Nephrotic Syndrome / Severe Hypoalbuminaemia",
    keywords: ["albumin", "20%", "nephrotic syndrome", "hypoalbuminaemia", "oedema", "0.5 g/kg", "1 g/kg", "with furosemide", "albucrit"],
    description: "0.5–1 g/kg IV over 2–4 hr (= 2.5–5 mL/kg of 20%). Give with furosemide in nephrotic. Monitor for pulmonary oedema",
  },
  {
    id: "drug-calcium-resonium",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "calcium-resonium",
    label: "Calcium Resonium — Hyperkalaemia (Non-Emergency / Chronic)",
    keywords: ["calcium resonium", "kayexalate", "hyperkalaemia", "chronic", "1 g/kg", "pr", "po", "not emergency", "not neonates"],
    description: "1 g/kg/dose PO or PR (max 15 g). Onset hours — NOT for emergency hyperK. Avoid in neonates (ileal necrosis)",
  },
  {
    id: "drug-sodium-zirconium",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "sodium-zirconium",
    label: "Sodium Zirconium Cyclosilicate (SZC) — Hyperkalaemia",
    keywords: ["sodium zirconium", "szc", "lokelma", "hyperkalaemia", "potassium binder", "10 g", "faster than resonium", "limited paediatric data"],
    description: "10 g PO TDS × 48 hr (adult; limited paediatric data). Faster onset than resonium (~1 hr). Safe post-op ileus",
  },

  // ─── RENAL — MISSING ───────────────────────────────────────────────────────
  {
    id: "drug-insulin-dka",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "insulin-dka",
    label: "Insulin Infusion — DKA",
    keywords: ["insulin", "dka", "diabetic ketoacidosis", "0.05 units/kg/hr", "0.1 units/kg/hr", "actrapid", "no bolus", "start after fluids"],
    description: "0.05–0.1 units/kg/hr IV infusion. Start ≥1 hr after fluids. NO IV bolus in DKA",
  },

  // ─── GI / HEPATIC — MISSING ────────────────────────────────────────────────
  {
    id: "drug-omeprazole-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "omeprazole-iv",
    label: "Omeprazole IV — GI Bleeding / PUD / GERD",
    keywords: ["omeprazole", "iv", "gi bleeding", "peptic ulcer", "gerd", "1 mg/kg", "ppi", "omez iv", "stress ulcer"],
    description: "0.5–1 mg/kg IV OD-BD (max 40 mg). GI bleed: bolus then 0.1–0.2 mg/kg/hr infusion. Switch to oral PPI early",
  },
  {
    id: "drug-ranitidine-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ranitidine-iv",
    label: "Ranitidine IV — Stress Ulcer Prophylaxis / GERD (Note: Recall Issues)",
    keywords: ["ranitidine", "iv", "stress ulcer prophylaxis", "gerd", "h2 blocker", "ndma recall", "rantac", "zinetac", "1 mg/kg"],
    description: "1–2 mg/kg IV q6–8h (max 50 mg). NDMA recalls in many countries — PPIs preferred when available",
  },
  {
    id: "drug-metoclopramide-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "metoclopramide-iv",
    label: "Metoclopramide IV — Vomiting / Gastric Dysmotility / Migraine",
    keywords: ["metoclopramide", "perinorm", "reglan", "iv", "vomiting", "gastric dysmotility", "migraine", "0.1 mg/kg", "dystonia", "avoid <1 yr"],
    description: "0.1 mg/kg IV over 5 min (max 10 mg). Extrapyramidal reactions — give diphenhydramine as rescue. Avoid <1 yr",
  },
  {
    id: "drug-neomycin-gi",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "neomycin-gi",
    label: "Neomycin PO — Hepatic Encephalopathy / Bowel Preparation",
    keywords: ["neomycin", "hepatic encephalopathy", "bowel preparation", "gut decontamination", "50 mg/kg", "ammonia", "non absorbable", "lactulose adjunct"],
    description: "50 mg/kg/day ÷ QDS (max 2 g/day). Non-absorbable — reduces ammonia-producing gut flora. Use with lactulose",
  },
  // ─── NEW IV DRUGS — SEARCH INDEX ENTRIES ──────────────────────────────────
  { id: "drug-salbutamol-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "salbutamol-iv",
    label: "Salbutamol IV — Severe / Critical Asthma",
    keywords: ["salbutamol","iv","asthma","critical asthma","15 mcg/kg","ventorlin iv","asthalin iv","bronchospasm","infusion"],
    description: "Load 15 mcg/kg over 10 min then 1–5 mcg/kg/min. Monitor HR, K⁺, glucose" },

  { id: "drug-aminophylline-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "aminophylline-iv",
    label: "Aminophylline IV — Severe Asthma / Apnoea of Prematurity",
    keywords: ["aminophylline","iv","severe asthma","apnoea prematurity","5 mg/kg","deriphyllin","narrow therapeutic index","theophylline"],
    description: "5 mg/kg IV over 20–30 min (max 500 mg). Maintenance 0.5–1 mg/kg/hr. Monitor ECG" },

  { id: "drug-tramadol-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "tramadol-iv",
    label: "Tramadol IV/IM — Moderate-Severe Pain (>12 yr)",
    keywords: ["tramadol","iv","im","pain","tramazac","ultracet","avoid under 12","nausea","opioid like"],
    description: "1–2 mg/kg IV slow over 15 min (max 100 mg). Avoid <12 yr. Nausea common — premedicate" },

  { id: "drug-diclofenac-im", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "diclofenac-im",
    label: "Diclofenac IM/IV — Moderate-Severe Pain / Renal Colic",
    keywords: ["diclofenac","im","iv","voveran","nsaid","renal colic","post op pain","1 mg/kg","75 mg","not iv bolus"],
    description: "1 mg/kg IM (max 75 mg). IV: dilute in 100 mL NS over 30–60 min. NEVER IV bolus. Avoid dengue" },

  { id: "drug-metronidazole-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "metronidazole-iv",
    label: "Metronidazole IV — Anaerobic / Abdominal Sepsis / Brain Abscess",
    keywords: ["metronidazole","iv","anaerobic","abdominal sepsis","brain abscess","flagyl iv","metrogyl iv","7.5 mg/kg","c difficile"],
    description: "7.5 mg/kg IV q8h (max 500 mg) over 30–60 min. Switch to oral (100% bioavailability) when tolerated" },

  { id: "drug-clindamycin-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "clindamycin-iv",
    label: "Clindamycin IV — Necrotising Fasciitis / Toxin Suppression / Anaerobic",
    keywords: ["clindamycin","dalacin","iv","necrotising fasciitis","toxic shock","toxin suppression","group a strep","mrsa","osteomyelitis","10 mg/kg"],
    description: "10 mg/kg IV q6–8h (max 600 mg). Dilute — infuse over 30–60 min. NEVER rapid IV. Toxin suppressor in NF/TSS" },

  { id: "drug-azithromycin-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "azithromycin-iv",
    label: "Azithromycin IV — Severe CAP / Atypical Pneumonia",
    keywords: ["azithromycin","iv","cap","atypical pneumonia","legionella","mycoplasma","10 mg/kg","azithral iv","azee iv","qt prolongation"],
    description: "10 mg/kg IV OD (max 500 mg) over 60 min. NEVER bolus. Switch to oral as soon as tolerated" },

  { id: "drug-doxycycline-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "doxycycline-iv",
    label: "Doxycycline IV — Scrub Typhus / Rickettsial / Atypical Pneumonia (>8 yr)",
    keywords: ["doxycycline","iv","scrub typhus","rickettsial","atypical pneumonia","2.2 mg/kg","over 8 years","phlebitis"],
    description: "2.2 mg/kg IV q12h (max 100 mg) over 1–4 hr. Only >8 yr. Switch to oral early" },

  { id: "drug-thiamine-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "thiamine-iv",
    label: "Thiamine IV — Before Glucose in Encephalopathy / Wernicke's",
    keywords: ["thiamine","vitamin b1","iv","im","wernicke","encephalopathy","before glucose","malnourished","alcoholic","neurobion iv"],
    description: "1–2 mg/kg IV over 30 min BEFORE glucose in malnourished/encephalopathic patients. Anaphylaxis risk if rapid IV" },

  { id: "drug-activated-charcoal", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "activated-charcoal",
    label: "Activated Charcoal — Acute Poisoning GI Decontamination",
    keywords: ["activated charcoal","poisoning","decontamination","1 g/kg","medichar","within 2 hours","overdose","not for acids","not for iron","not for hydrocarbons"],
    description: "1 g/kg PO/NG (max 50 g) within 1–2 hr of ingestion. NOT for: acids, alkalis, hydrocarbons, iron, lithium" },

  { id: "drug-hydroxocobalamin-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "hydroxocobalamin-iv",
    label: "Hydroxocobalamin IV — Cyanide Poisoning / Smoke Inhalation",
    keywords: ["hydroxocobalamin","cyanokit","cyanide","smoke inhalation","70 mg/kg","red discolouration","antidote","house fire"],
    description: "70 mg/kg IV (max 5 g) over 15 min. Turns urine/skin red — harmless. Up to 3 doses" },

  { id: "drug-sodium-thiosulfate-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "sodium-thiosulfate-iv",
    label: "Sodium Thiosulfate IV — Cyanide Poisoning",
    keywords: ["sodium thiosulfate","cyanide","400 mg/kg","25% solution","cyanide antidote","after sodium nitrite","smoke inhalation"],
    description: "400 mg/kg IV over 10 min. Use after sodium nitrite. More available than hydroxocobalamin in India" },

  { id: "drug-potassium-chloride-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "potassium-chloride-iv",
    label: "Potassium Chloride IV — Hypokalaemia (NEVER Bolus)",
    keywords: ["potassium chloride","kcl","hypokalaemia","iv infusion","never bolus","0.3 meq/kg/hr","ecg monitoring","must dilute","fatal if undiluted"],
    description: "0.3–0.5 mEq/kg/hr infusion. Max 40 mEq/L peripheral. NEVER undiluted or as IV push — fatal" },

  { id: "drug-isoprenaline-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "isoprenaline-iv",
    label: "Isoprenaline Infusion — Complete Heart Block / Refractory Bradycardia",
    keywords: ["isoprenaline","isoproterenol","complete heart block","refractory bradycardia","bridge to pacing","0.05 mcg/kg/min","chronotrope","chb"],
    description: "0.05–2 mcg/kg/min IV. Bridge to pacing in CHB/refractory bradycardia. β1+β2 agonist — vasodilation risk" },

  { id: "drug-proxymetacaine-eye", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "proxymetacaine-eye",
    label: "Proxymetacaine 0.5% Eye Drops — Topical Ocular Anaesthesia",
    keywords: ["proxymetacaine","proparacaine","alcaine","topical ocular anaesthesia","corneal fb","corneal abrasion","tonometry","1-2 drops","ophthalmology ed"],
    description: "1–2 drops topically. Onset 30 s, duration 15–20 min. Do NOT give bottle to patient — repeated use causes corneal damage" },

  { id: "drug-pyridoxine-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "pyridoxine-iv",
    label: "Pyridoxine IV — INH Toxicity Seizures / Pyridoxine-Dependent Epilepsy",
    keywords: ["pyridoxine","vitamin b6","iv","inh toxicity","isoniazid overdose","gram for gram","pyridoxine dependent epilepsy","neonatal seizures"],
    description: "INH OD: gram-for-gram with INH ingested (if unknown: 70 mg/kg IV). Pyridoxine-dependent epilepsy: 100 mg IV trial" },

  { id: "drug-lacosamide-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "lacosamide-iv",
    label: "Lacosamide IV — Status Epilepticus 2nd/3rd Line / Focal Epilepsy",
    keywords: ["lacosamide","iv","status epilepticus","second line","third line","5 mg/kg","vimpat","lacosam","pr prolongation","focal epilepsy"],
    description: "5 mg/kg IV over 15–60 min (max 300 mg). 2nd/3rd line SE. Minimal haemodynamic effects. Switch to PO early" },

// ─── NEW ORAL DRUGS — SEARCH INDEX ENTRIES ────────────────────────────────
  { id: "syrup-tramadol", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Analgesic", drugId: "tramadol-oral",
    label: "Tramadol Oral — Moderate Pain (>12 yr Only)",
    keywords: ["tramadol","oral","tramazac","ultracet","pain","avoid under 12","schedule h","nausea","seizure threshold"],
    description: "1–2 mg/kg TDS (max 100 mg). AVOID <12 yr. Nausea common" },

  { id: "syrup-diclofenac", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Analgesic", drugId: "diclofenac-oral",
    label: "Diclofenac Oral — Moderate Pain / Renal Colic",
    keywords: ["diclofenac","oral","voveran","nsaid","pain","renal colic","1 mg/kg","avoid dengue","syrup"],
    description: "1 mg/kg TDS (max 50 mg). Give with food. Avoid dengue, dehydration, renal impairment" },

  { id: "syrup-oseltamivir", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "oseltamivir-oral",
    label: "Oseltamivir Syrup — Influenza A/B",
    keywords: ["oseltamivir","tamiflu","fluvir","osiflu","influenza","syrup","within 48 hours","prophylaxis","weight based"],
    description: "Weight-based BD × 5 days. Start within 48 hr. ICU: 150 mg BD. Prophylaxis: half dose OD × 10 days" },

  { id: "syrup-rifaximin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "rifaximin-oral",
    label: "Rifaximin — Hepatic Encephalopathy / Traveller's Diarrhoea",
    keywords: ["rifaximin","rcifax","xifaxan","hepatic encephalopathy","traveller diarrhoea","non absorbable","550 mg","200 mg"],
    description: "HE: 550 mg BD. Traveller's diarrhoea: 200 mg TDS × 3 days. Non-absorbable — acts locally" },

  { id: "syrup-acetazolamide", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "acetazolamide-oral",
    label: "Acetazolamide — Glaucoma / Altitude Sickness / Pseudotumour Cerebri",
    keywords: ["acetazolamide","diamox","glaucoma","angle closure","altitude sickness","pseudotumour","5 mg/kg","carbonic anhydrase"],
    description: "5–10 mg/kg BD (max 250 mg BD). Glaucoma, altitude sickness, pseudotumour cerebri" },

  { id: "syrup-prazosin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "prazosin-oral",
    label: "Prazosin PO — Scorpion Envenomation / Hypertensive Urgency",
    keywords: ["prazosin","minipress","scorpion","envenomation","autonomic storm","0.03 mg/kg","every 3 hours","bawaskar","alpha blocker","first dose supine"],
    description: "Scorpion: 30 mcg/kg PO q3h (IAP). First dose supine. α1-blocker reverses catecholamine surge" },

  // ─── FLUIDS — MISSING ──────────────────────────────────────────────────────
  {
    id: "drug-dextrose-25",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "dextrose-25",
    label: "Dextrose 25% — Hypoglycaemia (Child >1 Month)",
    keywords: ["dextrose", "d25w", "25%", "glucose", "hypoglycaemia", "2 mL/kg", "large vein", "central", "not neonates"],
    description: "2 mL/kg IV = 0.5 g/kg glucose. Give via large vein. Not for neonates — use D10W",
  },
  {
    id: "drug-hypertonic-saline",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "hypertonic-saline",
    label: "Hypertonic Saline 3% — Raised ICP / Symptomatic Hyponatraemia",
    keywords: ["hypertonic saline", "3%", "raised icp", "hyponatraemia", "sodium correction", "4 mL/kg", "osmotherapy", "tbi", "cerebral oedema"],
    description: "Raised ICP: 4 mL/kg bolus over 10–20 min. Hyponatraemia: 2 mL/kg over 10–20 min. Monitor Na⁺",
  },

  // ─── NEUROMUSCULAR BLOCKING — MISSING ─────────────────────────────────────
  {
    id: "drug-vecuronium",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "vecuronium",
    label: "Vecuronium — Non-RSI Paralysis / ICU Paralysis",
    keywords: ["vecuronium", "non depolarising", "icu paralysis", "intubation", "0.1 mg/kg", "non rsi", "no cardiovascular effects"],
    description: "0.1 mg/kg IV. Onset 2–3 min. Duration 25–40 min. Infusion: 0.05–0.1 mg/kg/hr. No cardiovascular effects",
  },
  {
    id: "drug-cisatracurium",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "cisatracurium",
    label: "Cisatracurium — ICU Paralysis (Renal/Hepatic Failure Safe)",
    keywords: ["cisatracurium", "icu paralysis", "renal failure", "hepatic failure", "hofmann elimination", "0.15 mg/kg", "no histamine", "ards"],
    description: "0.15 mg/kg bolus, then 1–3 mcg/kg/min infusion. Hofmann elimination — safe in organ failure",
  },

  // ─── LOCAL ANAESTHETICS — MISSING ─────────────────────────────────────────
  {
    id: "drug-lidocaine-local",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "lidocaine-local",
    label: "Lidocaine — Local Anaesthesia Max Dose",
    keywords: ["lidocaine", "lignocaine", "local anaesthesia", "max dose", "4.5 mg/kg", "7 mg/kg with epi", "1%", "2%", "infiltration"],
    description: "Max 4.5 mg/kg plain (7 mg/kg with adrenaline). 1% = 10 mg/mL · 2% = 20 mg/mL",
  },
  {
    id: "drug-bupivacaine-local",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "bupivacaine-local",
    label: "Bupivacaine — Local / Regional Anaesthesia / Nerve Blocks",
    keywords: ["bupivacaine", "marcaine", "local anaesthesia", "nerve block", "max dose", "2 mg/kg", "cardiotoxic", "last", "intralipid", "regional"],
    description: "Max 2 mg/kg (2.5 mg/kg with adrenaline). 0.25% = 2.5 mg/mL. Cardiotoxic in overdose — intralipid rescue",
  },

  // ─── PAEDIATRIC ANALGESIA — MISSING ───────────────────────────────────────
  {
    id: "drug-sucrose-24",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "sucrose-24",
    label: "Sucrose 24% (Sweet-Ease) — Procedural Analgesia Neonate",
    keywords: ["sucrose", "sweet ease", "procedural analgesia", "neonate", "infant", "heel prick", "venepuncture", "non pharmacological", "0-3 months"],
    description: "0.5–2 mL onto tongue 2 min pre-procedure. For neonates/infants ≤3 months. Combine with non-nutritive sucking",
  },
  {
    id: "drug-nitrous-oxide",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "nitrous-oxide",
    label: "Nitrous Oxide / O₂ (Entonox 50:50) — Procedural Analgesia",
    keywords: ["nitrous oxide", "entonox", "n2o", "self administered", "procedural analgesia", "cannula insertion", "dressing change", "cooperative", "age 5"],
    description: "Self-administered 50% N₂O / 50% O₂. ≥5 yr cooperative child. Onset 30–60 s, offset ~5 min",
  },
  {
    id: "drug-ondansetron-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "GI/Hepatic", drugId: "ondansetron-iv",
    label: "Ondansetron IV — Post-op Nausea / Vomiting",
    keywords: ["ondansetron", "iv", "vomiting", "post op nausea", "ponv", "0.15 mg/kg", "emeset", "ondem", "zofran", "qt prolongation"],
    description: "0.15 mg/kg IV over 15 min (max 4 mg if <15 kg; 8 mg if ≥15 kg). Avoid in long QT",
  },

  // ─── RESPIRATORY — MISSING ────────────────────────────────────────────────
  {
    id: "drug-racemic-epi",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "racemic-epi",
    label: "Racemic Epinephrine Neb — Croup / Post-extubation Stridor",
    keywords: ["racemic epinephrine", "croup", "stridor", "post extubation stridor", "0.05 mL/kg", "2.25%", "rebound stridor", "observe 4 hr"],
    description: "0.05 mL/kg of 2.25% neb (max 0.5 mL). Observe ≥2–4 hr for rebound stridor. Adrenaline 1:1000 acceptable alternative",
  },

  // ─── NEONATAL — MISSING ────────────────────────────────────────────────────
  {
    id: "drug-adrenaline-neonatal",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "adrenaline-neonatal",
    label: "Adrenaline — Neonatal NRP (HR <60 Despite PPV)",
    keywords: ["adrenaline", "neonatal", "nrp", "hr less than 60", "ppv", "uvc", "umbilical venous catheter", "0.01 mg/kg", "0.03 mg/kg", "newborn resuscitation"],
    description: "0.01–0.03 mg/kg IV via UVC (preferred). ETT: 0.05–0.1 mg/kg if IV unavailable. Repeat q3–5 min",
  },
  {
    id: "drug-volume-neonate",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "volume-neonate",
    label: "Volume Expander — Neonatal NRP / Hypovolaemic Shock",
    keywords: ["volume expander", "neonate", "nrp", "hypovolaemia", "10 mL/kg", "normal saline", "o negative blood", "uvc", "newborn shock"],
    description: "10 mL/kg NS or O-negative blood IV/UVC over 5–10 min. May repeat once",
  },
  {
    id: "drug-naloxone-neonate",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "naloxone-neonate",
    label: "Naloxone Neonatal — Opioid-Induced Respiratory Depression (Not Routine NRP)",
    keywords: ["naloxone", "neonate", "neonatal", "opioid respiratory depression", "not nrp", "0.1 mg/kg", "maternal opioids", "avoid chronic opioid mother"],
    description: "0.1 mg/kg IV/IM. NOT first-line in NRP — focus on ventilation. Avoid if mother on chronic opioids",
  },

  // ─── ANTIVIRAL — MISSING ───────────────────────────────────────────────────
  {
    id: "drug-ribavirin-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ribavirin-iv",
    label: "Ribavirin IV/Inhaled — RSV Severe / Lassa Fever / CCHF",
    keywords: ["ribavirin", "rsv severe", "lassa fever", "cchf", "haemorrhagic fever", "33 mg/kg", "inhaled rsv", "spag2", "immunocompromised rsv"],
    description: "Haemorrhagic fever: 33 mg/kg load then 16 mg/kg q6h × 4d then 8 mg/kg q8h × 6d. RSV inhaled: SPAG-2 device",
  },
  {
    id: "drug-chloroquine-iv",
    tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "chloroquine-iv",
    label: "Chloroquine IV/IM — P. vivax / Malaria When Oral Not Possible",
    keywords: ["chloroquine", "iv", "im", "vivax", "malaria", "10 mg/kg", "oral unavailable", "cardiotoxic", "ecg monitor", "lariago iv", "malirid"],
    description: "IV: 10 mg base/kg over 8 hr then 5 mg base/kg q12h. Cardiotoxic if rapid IV — monitor ECG. Switch to oral ASAP",
  },  
  {
    id: "drug-adrenaline-arrest", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "adrenaline-arrest",
    label: "Adrenaline — Cardiac Arrest",
    keywords: ["adrenaline", "epinephrine", "cardiac arrest", "0.01 mg/kg", "1:10000", "iv", "io"],
    description: "0.01 mg/kg IV/IO (0.1 mL/kg of 1:10,000). Repeat every 3–5 min",
  },
  {
    id: "drug-adrenaline-im", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "adrenaline-im",
    label: "Adrenaline IM — Anaphylaxis",
    keywords: ["adrenaline", "epinephrine", "anaphylaxis", "im", "1:1000", "anterolateral thigh", "epipen", "0.01 mg/kg"],
    description: "0.01 mg/kg IM (max 0.5 mg) anterolateral thigh. Repeat q5–15 min",
  },
  {
    id: "drug-atropine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "atropine",
    label: "Atropine — Bradycardia / Pre-intubation",
    keywords: ["atropine", "bradycardia", "pre intubation", "0.02 mg/kg", "slow heart rate"],
    description: "0.02 mg/kg IV (min 0.1 mg, max 0.5 mg). HR <60 + poor perfusion → CPR",
  },
  {
    id: "drug-adenosine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "adenosine",
    label: "Adenosine — SVT",
    keywords: ["adenosine", "svt", "supraventricular tachycardia", "rapid push", "0.1 mg/kg"],
    description: "0.1 mg/kg rapid IV push (max 6 mg). 2nd dose 0.2 mg/kg (max 12 mg)",
  },
  {
    id: "drug-amiodarone", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "amiodarone",
    label: "Amiodarone — VF/VT / SVT",
    keywords: ["amiodarone", "vf", "vt", "svt", "refractory", "5 mg/kg"],
    description: "5 mg/kg IV/IO bolus (max 300 mg) for refractory VF/pulseless VT",
  },
  {
    id: "drug-naloxone", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "naloxone",
    label: "Naloxone — Opioid Overdose",
    keywords: ["naloxone", "narcan", "opioid", "overdose", "reversal", "respiratory depression"],
    description: "0.1 mg/kg IV/IM/IN (max 2 mg). Titrate to respiratory response",
  },
  {
    id: "drug-calcium-gluconate", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "calcium-gluconate",
    label: "Calcium Gluconate 10% — Hypocalcaemia / HyperK",
    keywords: ["calcium gluconate", "hypocalcaemia", "hyperkalaemia", "ccb overdose", "calcium", "0.5 mL/kg"],
    description: "0.5 mL/kg of 10% IV slow (max 20 mL). 100 mg/kg for hyperK",
  },
  {
    id: "drug-calcium-chloride", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "calcium-chloride",
    label: "Calcium Chloride 10% — Cardiac Arrest",
    keywords: ["calcium chloride", "cardiac arrest", "ccb", "0.2 mL/kg"],
    description: "0.2 mL/kg of 10% IV central (max 10 mL). 3× more elemental Ca than gluconate",
  },
  {
    id: "drug-magnesium", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "magnesium-sulfate",
    label: "Magnesium Sulfate — Severe Asthma / Torsades",
    keywords: ["magnesium", "mgso4", "severe asthma", "torsades", "25 mg/kg", "50 mg/kg"],
    description: "25–50 mg/kg IV over 20 min (max 2 g). Monitor for hypotension",
  },
  {
    id: "drug-sodium-bicarb", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "sodium-bicarb",
    label: "Sodium Bicarbonate — Metabolic Acidosis / HyperK",
    keywords: ["sodium bicarbonate", "bicarb", "metabolic acidosis", "hyperkalaemia", "tca overdose", "1 meq/kg"],
    description: "1 mEq/kg IV slow. Not routine in arrest. Dilute in neonates",
  },
  {
    id: "drug-hydrocortisone", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "hydrocortisone",
    label: "Hydrocortisone — Shock / Adrenal Crisis / Asthma",
    keywords: ["hydrocortisone", "steroid", "adrenal crisis", "septic shock", "severe asthma", "2 mg/kg"],
    description: "2 mg/kg IV (max 100 mg). Adrenal crisis: 50–100 mg stat",
  },
  {
    id: "drug-ketamine-rsi", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ketamine-rsi",
    label: "Ketamine — RSI Induction",
    keywords: ["ketamine", "rsi", "rapid sequence intubation", "induction", "2 mg/kg", "shock", "asthma"],
    description: "2 mg/kg IV. Preferred in shock/asthma. Bronchodilator",
  },
  {
    id: "drug-ketamine-sedation", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ketamine-sedation",
    label: "Ketamine — Procedural Sedation",
    keywords: ["ketamine", "procedural sedation", "psa", "dissociative", "1.5 mg/kg", "im", "4 mg/kg"],
    description: "1–2 mg/kg IV or 4–5 mg/kg IM. Preserves airway. Onset 1 min IV",
  },
  {
    id: "drug-propofol", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "propofol",
    label: "Propofol — RSI / Procedural Sedation",
    keywords: ["propofol", "rsi", "induction", "sedation", "2 mg/kg", "hypotension"],
    description: "2 mg/kg IV. Hypotension risk. Avoid in shock. No analgesia",
  },
  {
    id: "drug-etomidate", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "etomidate",
    label: "Etomidate — RSI Haemodynamically Unstable",
    keywords: ["etomidate", "rsi", "haemodynamically unstable", "0.3 mg/kg"],
    description: "0.3 mg/kg IV. Haemodynamically neutral. Avoid in septic shock",
  },
  {
    id: "drug-midazolam-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "midazolam-iv",
    label: "Midazolam IV — Sedation / Status Epilepticus",
    keywords: ["midazolam", "iv", "sedation", "status epilepticus", "icu", "0.1 mg/kg", "benzo"],
    description: "0.05–0.1 mg/kg IV (max 5 mg). Reversible with flumazenil",
  },
  {
    id: "drug-midazolam-in", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "midazolam-in",
    label: "Midazolam IN/Buccal — Seizure Without IV",
    keywords: ["midazolam", "intranasal", "buccal", "seizure", "no iv", "0.2 mg/kg", "in midazolam"],
    description: "0.2 mg/kg IN or buccal (max 10 mg). Onset 5–10 min",
  },
  {
    id: "drug-dexmedetomidine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "dexmedetomidine",
    label: "Dexmedetomidine — ICU Sedation / MRI",
    keywords: ["dexmedetomidine", "precedex", "icu sedation", "mri", "alpha2", "no respiratory depression"],
    description: "Load 0.5–1 mcg/kg over 10 min, then 0.2–0.7 mcg/kg/hr",
  },
  {
    id: "drug-suxamethonium", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "suxamethonium",
    label: "Suxamethonium — RSI Paralysis",
    keywords: ["suxamethonium", "succinylcholine", "rsi", "paralysis", "nmb", "2 mg/kg", "depolarising"],
    description: "2 mg/kg IV. Onset 30–60 s. Contraindicated in hyperK, burns, crush injury",
  },
  {
    id: "drug-rocuronium", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "rocuronium",
    label: "Rocuronium — RSI / Intubation",
    keywords: ["rocuronium", "rsi", "paralysis", "nmb", "1.2 mg/kg", "sugammadex", "non depolarising"],
    description: "1.2 mg/kg IV. Onset 60 s. Reversible with sugammadex 16 mg/kg",
  },
  {
    id: "drug-lorazepam", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "lorazepam",
    label: "Lorazepam IV — Status Epilepticus First Line",
    keywords: ["lorazepam", "ativan", "status epilepticus", "seizure", "benzodiazepine", "0.1 mg/kg", "first line benzo"],
    description: "0.1 mg/kg IV (max 4 mg). First-line IV benzo for SE. Duration 12–24 hr",
  },
  {
    id: "drug-diazepam", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "diazepam-iv",
    label: "Diazepam IV/PR — Status Epilepticus / Febrile Seizure",
    keywords: ["diazepam", "valium", "status epilepticus", "febrile convulsion", "rectal", "pr", "0.2 mg/kg"],
    description: "0.2 mg/kg IV or 0.5 mg/kg PR (max 10 mg). PR if no IV access",
  },
  {
    id: "drug-levetiracetam", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "levetiracetam-iv",
    label: "Levetiracetam IV — Status Epilepticus 2nd Line",
    keywords: ["levetiracetam", "keppra", "levipil", "status epilepticus", "seizure", "40 mg/kg", "second line"],
    description: "40–60 mg/kg IV over 5–15 min (max 3 g). After benzos fail",
  },
  {
    id: "drug-phenytoin", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "phenytoin",
    label: "Phenytoin / Fosphenytoin — Status Epilepticus",
    keywords: ["phenytoin", "fosphenytoin", "status epilepticus", "seizure", "20 mg/kg", "ecg monitoring"],
    description: "20 mg PE/kg IV (max 1500 mg). ECG monitoring mandatory",
  },
  {
    id: "drug-phenobarbital", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "phenobarbital-iv",
    label: "Phenobarbital IV — Status Epilepticus 3rd Line / Neonatal",
    keywords: ["phenobarbital", "phenobarbitone", "status epilepticus", "neonatal seizures", "20 mg/kg", "third line"],
    description: "20 mg/kg IV slow (max 600 mg). Neonatal SE first line",
  },
  {
    id: "drug-valproate", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "valproate-iv",
    label: "Sodium Valproate IV — Status Epilepticus",
    keywords: ["valproate", "sodium valproate", "valparin", "status epilepticus", "30 mg/kg"],
    description: "30–40 mg/kg IV over 5–10 min (max 3 g)",
  },
  {
    id: "drug-thiopentone", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "thiopentone-iv",
    label: "Thiopentone — Refractory Status Epilepticus",
    keywords: ["thiopentone", "thiopental", "pentothal", "refractory status", "rse", "burst suppression"],
    description: "3–5 mg/kg IV then 1–5 mg/kg/hr. Requires intubation + EEG",
  },
  {
    id: "drug-morphine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "morphine-iv",
    label: "Morphine IV/IM — Severe Pain",
    keywords: ["morphine", "opioid", "severe pain", "0.1 mg/kg", "iv", "im"],
    description: "0.05–0.1 mg/kg IV q2–4h (max 5 mg). Have naloxone ready",
  },
  {
    id: "drug-fentanyl-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "fentanyl-iv",
    label: "Fentanyl IV — Procedural / Severe Pain",
    keywords: ["fentanyl", "iv", "procedural", "severe pain", "1 mcg/kg", "rsi analgesia", "chest wall rigidity"],
    description: "1–2 mcg/kg IV slow over 3–5 min (max 50 mcg)",
  },
  {
    id: "drug-fentanyl-in", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "fentanyl-in",
    label: "Fentanyl IN — Acute Pain Without IV",
    keywords: ["fentanyl", "intranasal", "in", "no iv", "trauma", "1.5 mcg/kg", "atomiser"],
    description: "1.5 mcg/kg IN via atomiser (max 100 mcg). Onset 5–10 min",
  },
  {
    id: "drug-ketamine-analgesia", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ketamine-analgesia",
    label: "Ketamine Sub-dissociative — Acute Pain",
    keywords: ["ketamine", "sub dissociative", "sdk", "analgesia", "0.3 mg/kg", "opioid sparing"],
    description: "0.2–0.5 mg/kg IV over 10 min (max 30 mg). Opioid-sparing",
  },
  {
    id: "drug-ketorolac", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ketorolac-iv",
    label: "Ketorolac IV/IM — Moderate Pain / Renal Colic",
    keywords: ["ketorolac", "toradol", "nsaid", "renal colic", "0.5 mg/kg"],
    description: "0.5 mg/kg IV q6h (max 30 mg/dose). Avoid >5 days or renal impairment",
  },
  {
    id: "drug-paracetamol-iv", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "paracetamol-iv",
    label: "Paracetamol IV (Perfalgan) — Pain / Fever",
    keywords: ["paracetamol", "perfalgan", "acetaminophen", "iv", "fever", "15 mg/kg"],
    description: "15 mg/kg IV over 15 min q6h (max 1 g/dose). Switch to oral ASAP",
  },
  {
    id: "drug-dopamine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "dopamine",
    label: "Dopamine Infusion — Shock",
    keywords: ["dopamine", "inotrope", "vasopressor", "shock", "2-20 mcg/kg/min"],
    description: "2–20 mcg/kg/min. Renal 2–5, β 5–10, α >10 mcg/kg/min",
  },
  {
    id: "drug-noradrenaline", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "noradrenaline",
    label: "Noradrenaline Infusion — Warm Septic Shock",
    keywords: ["noradrenaline", "norepinephrine", "vasopressor", "septic shock", "warm shock"],
    description: "0.05–1 mcg/kg/min IV. First-line vasopressor in warm septic shock",
  },
  {
    id: "drug-adrenaline-infusion", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "adrenaline-infusion",
    label: "Adrenaline Infusion — Cold Septic Shock",
    keywords: ["adrenaline", "epinephrine", "infusion", "cold shock", "0.05 mcg/kg/min"],
    description: "0.05–1 mcg/kg/min IV. First-line in cold shock",
  },
  {
    id: "drug-dobutamine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "dobutamine",
    label: "Dobutamine Infusion — Cardiogenic Shock",
    keywords: ["dobutamine", "inotrope", "cardiogenic shock", "heart failure"],
    description: "2–20 mcg/kg/min. β1 inotrope. Titrate to perfusion",
  },
  {
    id: "drug-milrinone", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "milrinone",
    label: "Milrinone — Low CO / Post Cardiac Surgery",
    keywords: ["milrinone", "phosphodiesterase", "low cardiac output", "post cardiac surgery"],
    description: "Load 50 mcg/kg then 0.25–0.75 mcg/kg/min",
  },
  {
    id: "drug-ceftriaxone", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "ceftriaxone",
    label: "Ceftriaxone IV — Sepsis / Meningitis / Enteric Fever",
    keywords: ["ceftriaxone", "rocephin", "sepsis", "meningitis", "enteric fever", "50 mg/kg", "100 mg/kg"],
    description: "Sepsis: 50 mg/kg OD. Meningitis: 100 mg/kg OD (max 4 g)",
  },
  {
    id: "drug-meropenem", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "meropenem-iv",
    label: "Meropenem IV — Severe Sepsis / MDR",
    keywords: ["meropenem", "meronem", "carbapenem", "severe sepsis", "mdr", "gram negative"],
    description: "Sepsis: 20 mg/kg q8h. Meningitis: 40 mg/kg q8h (max 2 g)",
  },
  {
    id: "drug-vancomycin", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "vancomycin-iv",
    label: "Vancomycin IV — MRSA / Resistant Gram-positive",
    keywords: ["vancomycin", "mrsa", "gram positive", "resistant", "15 mg/kg"],
    description: "15 mg/kg q6–8h IV over 60 min. Target trough 15–20 mcg/mL",
  },
  {
    id: "drug-gentamicin", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "gentamicin",
    label: "Gentamicin IV — Gram-negative / Neonatal Sepsis",
    keywords: ["gentamicin", "aminoglycoside", "gram negative", "neonatal sepsis", "7.5 mg/kg"],
    description: "7.5 mg/kg OD IV. Neonates: 4–5 mg/kg q24–48h. Monitor levels",
  },
  {
    id: "drug-piptaz", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "piptaz-iv",
    label: "Piperacillin-Tazobactam — Nosocomial / Pseudomonas",
    keywords: ["piperacillin", "tazobactam", "pip taz", "tazocin", "pseudomonas", "nosocomial", "febrile neutropenia"],
    description: "100 mg/kg q8h IV. Severe: q6h",
  },
  {
    id: "drug-acyclovir", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "acyclovir-iv",
    label: "Acyclovir IV — HSV Encephalitis / Neonatal HSV",
    keywords: ["acyclovir", "zovirax", "hsv", "herpes", "encephalitis", "neonatal", "20 mg/kg"],
    description: "HSV encephalitis: 20 mg/kg q8h × 14–21 days",
  },
  {
    id: "drug-artesunate", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "artesunate-iv",
    label: "Artesunate IV — Severe Falciparum Malaria",
    keywords: ["artesunate", "falcigo", "malaria", "falciparum", "severe malaria", "2.4 mg/kg"],
    description: "2.4 mg/kg at 0, 12, 24 hr then OD (min 3 days)",
  },
  {
    id: "drug-caffeine", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "caffeine-citrate",
    label: "Caffeine Citrate — Apnoea of Prematurity",
    keywords: ["caffeine", "caffeine citrate", "apnoea", "prematurity", "20 mg/kg"],
    description: "Load 20 mg/kg IV/PO, maintenance 5–10 mg/kg/day",
  },
  {
    id: "drug-surfactant", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "surfactant",
    label: "Surfactant — Neonatal RDS",
    keywords: ["surfactant", "poractant", "curosurf", "beractant", "survanta", "rds", "neonatal"],
    description: "Poractant 200 mg/kg ET. Beractant 100 mg/kg ET",
  },
  {
    id: "drug-pge1", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "prostaglandin-e1",
    label: "Prostaglandin E1 — Duct-Dependent Heart Disease",
    keywords: ["prostaglandin", "pge1", "alprostadil", "ductus", "pda", "congenital heart"],
    description: "0.05–0.1 mcg/kg/min IV. Keep ductus open",
  },
  {
    id: "drug-dextrose", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "dextrose",
    label: "Dextrose 10% — Hypoglycaemia",
    keywords: ["dextrose", "d10w", "glucose", "hypoglycaemia", "2 mL/kg"],
    description: "2 mL/kg D10W IV = 0.2 g/kg glucose",
  },
  {
    id: "drug-mannitol", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "mannitol",
    label: "Mannitol 20% — Raised ICP",
    keywords: ["mannitol", "icp", "raised intracranial pressure", "tbi", "0.5 g/kg", "osmotherapy"],
    description: "0.5 g/kg IV over 20 min (= 2.5 mL/kg of 20%). Monitor osmolality",
  },
  {
    id: "drug-furosemide", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "furosemide-iv",
    label: "Furosemide IV — Fluid Overload / Pulmonary Oedema",
    keywords: ["furosemide", "lasix", "frusemide", "diuretic", "fluid overload", "pulmonary oedema"],
    description: "0.5–1 mg/kg IV (max 40 mg). Monitor K⁺",
  },
  {
    id: "drug-dexamethasone-croup", tab: "drugs", tabLabel: "Drugs",
    section: "Drug Doses", drugId: "dexamethasone-croup",
    label: "Dexamethasone — Croup",
    keywords: ["dexamethasone", "croup", "stridor", "0.6 mg/kg", "laryngotracheobronchitis"],
    description: "0.6 mg/kg PO/IM/IV single dose (max 10 mg). PO as effective as IM",
  },
  // ─── ANTIHYPERTENSIVES ─────────────────────────────────────────────────────
{
  id: "drug-labetalol-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "labetalol-iv",
  label: "Labetalol IV — Hypertensive Emergency",
  keywords: ["labetalol", "iv", "hypertensive emergency", "hypertension", "0.2 mg/kg", "alpha beta blocker"],
  description: "0.2–1 mg/kg IV over 2 min (max 40 mg). Infusion 0.25–3 mg/kg/hr. Avoid in asthma",
},
{
  id: "drug-hydralazine-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "hydralazine-iv",
  label: "Hydralazine IV/IM — Hypertensive Emergency / Eclampsia",
  keywords: ["hydralazine", "iv", "im", "hypertensive emergency", "eclampsia", "0.2 mg/kg", "nepresol"],
  description: "0.1–0.5 mg/kg IV/IM q4–6h (max 20 mg). Reflex tachycardia — combine with beta-blocker",
},
{
  id: "drug-nifedipine-sl", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "nifedipine-sl",
  label: "Nifedipine SL/PO — Hypertensive Urgency",
  keywords: ["nifedipine", "sublingual", "hypertensive urgency", "0.25 mg/kg", "not emergency", "ccb"],
  description: "0.25–0.5 mg/kg PO/SL (max 10 mg). NOT for emergency — precipitous fall. Onset 20–30 min",
},
{
  id: "drug-sodium-nitroprusside", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "sodium-nitroprusside",
  label: "Sodium Nitroprusside — Severe Hypertensive Emergency",
  keywords: ["sodium nitroprusside", "snp", "hypertensive emergency", "0.3 mcg/kg/min", "cyanide toxicity", "light protected", "arterial line"],
  description: "0.3–8 mcg/kg/min IV infusion. Light-protect tubing. Cyanide toxicity >72 hr or >3 mcg/kg/min",
},
{
  id: "drug-enalaprilat-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "enalaprilat-iv",
  label: "Enalaprilat IV — Hypertensive Emergency / Heart Failure",
  keywords: ["enalaprilat", "enalapril", "iv", "ace inhibitor", "hypertensive emergency", "heart failure", "0.005 mg/kg"],
  description: "0.005–0.01 mg/kg IV q8–24h (max 1.25 mg). Avoid in neonates and bilateral RAS",
},
{
  id: "drug-phentolamine-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "phentolamine-iv",
  label: "Phentolamine — Phaeochromocytoma Crisis / Extravasation",
  keywords: ["phentolamine", "phaeochromocytoma", "catecholamine", "extravasation", "0.1 mg/kg", "alpha blocker"],
  description: "0.05–0.1 mg/kg IV (max 5 mg). Extravasation: 5–10 mg in 10 mL NS infiltrated locally",
},
{
  id: "drug-clonidine-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "clonidine-iv",
  label: "Clonidine IV/PO — Hypertensive Urgency / Withdrawal",
  keywords: ["clonidine", "iv", "hypertensive urgency", "opioid withdrawal", "alcohol withdrawal", "alpha2 agonist", "catapres", "arkamin"],
  description: "IV: 2–6 mcg/kg over 10–15 min. PO: 5–10 mcg/kg/day ÷ BD-TDS. Rebound HTN if stopped abruptly",
},

// ─── ANTIARRHYTHMICS ───────────────────────────────────────────────────────
{
  id: "drug-procainamide-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "procainamide-iv",
  label: "Procainamide IV — SVT / VT / WPW",
  keywords: ["procainamide", "iv", "svt", "vt", "wpw", "adenosine refractory", "15 mg/kg", "class ia"],
  description: "15 mg/kg IV over 30–60 min (max 1 g). Preferred for WPW+SVT when adenosine fails",
},
{
  id: "drug-verapamil-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "verapamil-iv",
  label: "Verapamil IV — SVT (>1 yr ONLY)",
  keywords: ["verapamil", "iv", "svt", "0.1 mg/kg", "contraindicated infants", "calcium channel blocker", "age 1 year"],
  description: "0.1–0.3 mg/kg IV over 2 min (max 5 mg). CONTRAINDICATED <1 yr — fatal hypotension",
},
{
  id: "drug-digoxin-load", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "digoxin-load",
  label: "Digoxin IV Loading — SVT / Atrial Flutter",
  keywords: ["digoxin", "iv", "loading", "svt", "atrial flutter", "heart failure", "digitalising dose", "lanoxin", "tdd"],
  description: "TDD: 20–30 mcg/kg IV child. Give ½ stat then ¼ q8–12h × 2. Target level 0.8–2 ng/mL",
},

// ─── PULMONARY HYPERTENSION ────────────────────────────────────────────────
{
  id: "drug-sildenafil", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "sildenafil-iv",
  label: "Sildenafil PO/IV — PAH / PPHN",
  keywords: ["sildenafil", "revatio", "pulmonary hypertension", "pphn", "pah", "pde5", "0.5 mg/kg", "newborn"],
  description: "PO: 0.5–1 mg/kg/dose TDS-QDS (max 20 mg TDS). IV: 0.1 mg/kg TDS. PDE-5 inhibitor",
},
{
  id: "drug-bosentan", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "bosentan-po",
  label: "Bosentan PO — Pulmonary Arterial Hypertension",
  keywords: ["bosentan", "tracleer", "pulmonary hypertension", "pah", "endothelin receptor", "2 mg/kg", "hepatotoxic", "teratogenic"],
  description: "2 mg/kg BD × 4 wk then 4 mg/kg BD. Monitor LFTs monthly. Teratogenic",
},
{
  id: "drug-ino", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "nitric-oxide",
  label: "Inhaled Nitric Oxide — PPHN / Hypoxic Respiratory Failure",
  keywords: ["inhaled nitric oxide", "ino", "pphn", "hypoxic respiratory failure", "20 ppm", "selective pulmonary vasodilator", "inomax", "methaemoglobin"],
  description: "Start 20 ppm, titrate to 5–40 ppm. Wean slowly — rebound. Monitor metHb <2.5%",
},

// ─── ENDOCRINE ─────────────────────────────────────────────────────────────
{
  id: "drug-octreotide", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "octreotide",
  label: "Octreotide — Hyperinsulinaemic Hypoglycaemia / GI Bleed",
  keywords: ["octreotide", "sandostatin", "hyperinsulinism", "hypoglycaemia", "gi bleeding", "chylothorax", "somatostatin"],
  description: "Hypoglycaemia: 1–5 mcg/kg SC q6–8h. GI bleed: 1–2 mcg/kg bolus then infusion",
},
{
  id: "drug-desmopressin", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "desmopressin-iv",
  label: "Desmopressin (DDAVP) — Diabetes Insipidus / Bleeding",
  keywords: ["desmopressin", "ddavp", "minirin", "diabetes insipidus", "vwd", "haemophilia a", "0.3 mcg/kg", "enuresis", "hyponatraemia"],
  description: "DI: 0.05–0.3 mcg/kg IV/SC q12–24h. Bleeding: 0.3 mcg/kg IV over 30 min. Monitor Na⁺",
},
{
  id: "drug-ptu", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "propylthiouracil",
  label: "Propylthiouracil (PTU) — Thyroid Storm",
  keywords: ["ptu", "propylthiouracil", "thyroid storm", "hyperthyroidism", "5 mg/kg", "agranulocytosis", "blocks t4 t3"],
  description: "Thyroid storm: 5–7 mg/kg/dose q8h PO. Blocks T4→T3 conversion. Monitor WBC",
},
{
  id: "drug-methimazole", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "methimazole",
  label: "Methimazole / Carbimazole — Hyperthyroidism",
  keywords: ["methimazole", "carbimazole", "neomercazole", "thyrozol", "graves disease", "hyperthyroidism", "0.5 mg/kg", "agranulocytosis"],
  description: "0.5–1 mg/kg/day ÷ TDS (max 30 mg/day). Monitor TFTs q4–6 wk. Stop if fever/sore throat",
},

// ─── TOXICOLOGY ────────────────────────────────────────────────────────────
{
  id: "drug-nac", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "nac-iv",
  label: "N-Acetylcysteine (NAC) IV — Paracetamol Overdose",
  keywords: ["nac", "n acetylcysteine", "paracetamol overdose", "acetaminophen overdose", "150 mg/kg", "rumack", "liver failure", "acemuc"],
  description: "Phase 1: 150 mg/kg over 60 min → Phase 2: 50 mg/kg/4 hr → Phase 3: 100 mg/kg/16 hr",
},
{
  id: "drug-atropine-op", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "atropine-op",
  label: "Atropine — Organophosphate Poisoning",
  keywords: ["atropine", "organophosphate", "op poisoning", "carbamate", "0.05 mg/kg", "dry secretions", "no minimum dose", "cholinergic toxidrome"],
  description: "0.05 mg/kg IV (no minimum dose). Double q5–10 min until secretions dry. Endpoint: dry secretions",
},
{
  id: "drug-pralidoxime", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "pralidoxime",
  label: "Pralidoxime (2-PAM) — Organophosphate Poisoning",
  keywords: ["pralidoxime", "2 pam", "p2am", "organophosphate", "cholinesterase reactivation", "25 mg/kg", "within 24 hours"],
  description: "25–50 mg/kg IV over 15–30 min (max 2 g). Give within 24–36 hr. Use with atropine",
},
{
  id: "drug-intralipid", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "intralipid-20",
  label: "Intralipid 20% — Local Anaesthetic Systemic Toxicity (LAST)",
  keywords: ["intralipid", "lipid emulsion", "last", "local anaesthetic toxicity", "bupivacaine", "1.5 mL/kg", "cardiac arrest la"],
  description: "1.5 mL/kg IV bolus over 1 min then 0.25–0.5 mL/kg/min × 10 min. Max 10 mL/kg",
},
{
  id: "drug-digoxin-fab", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "digoxin-fab",
  label: "Digoxin-Fab (Digibind) — Severe Digoxin Toxicity",
  keywords: ["digoxin fab", "digibind", "digifab", "digoxin toxicity", "arrhythmia", "vials", "antidote"],
  description: "Vials = (level [ng/mL] × weight [kg]) ÷ 100. Each vial binds 0.5 mg digoxin",
},

// ─── HAEMATOLOGY ───────────────────────────────────────────────────────────
{
  id: "drug-tranexamic-acid", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "tranexamic-acid",
  label: "Tranexamic Acid (TXA) — Trauma / Surgical Bleeding",
  keywords: ["tranexamic acid", "txa", "pause", "tranexa", "trauma", "haemorrhage", "15 mg/kg", "antifibrinolytic", "within 3 hours"],
  description: "15 mg/kg IV over 10 min (max 1 g) then 2 mg/kg/hr × 8 hr. Within 3 hr of injury",
},
{
  id: "drug-ffp", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "ffp",
  label: "Fresh Frozen Plasma (FFP) — Coagulopathy / DIC",
  keywords: ["ffp", "fresh frozen plasma", "coagulopathy", "dic", "warfarin reversal", "liver disease", "15 mL/kg", "ttp"],
  description: "10–20 mL/kg IV over 30–60 min. ABO compatible. Thaw 20–30 min — plan ahead",
},
{
  id: "drug-platelets", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "platelets",
  label: "Platelet Transfusion — Thrombocytopaenia",
  keywords: ["platelets", "platelet transfusion", "thrombocytopaenia", "itp", "10 mL/kg", "threshold", "<10000", "<50000"],
  description: "5–10 mL/kg. Prophylactic threshold <10,000. Pre-procedure <50,000. Neurosurgery <100,000",
},
{
  id: "drug-ivig", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "ivig",
  label: "IVIG — Kawasaki / ITP / GBS",
  keywords: ["ivig", "intravenous immunoglobulin", "kawasaki", "itp", "gbs", "guillain barre", "2 g/kg", "biovac", "sandoglobulin"],
  description: "Kawasaki: 2 g/kg IV over 10–12 hr. ITP: 0.8–1 g/kg. GBS: 0.4 g/kg/day × 5 days",
},
{
  id: "drug-albumin-5", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "albumin-5",
  label: "Albumin 5% — Hypovolaemia / Septic Shock",
  keywords: ["albumin", "5%", "hypovolaemia", "septic shock", "hypoalbuminaemia", "sbp", "10 mL/kg", "albucrit"],
  description: "10–20 mL/kg IV for volume expansion. SBP: 1.5 g/kg day 1. Preferred in liver disease",
},
{
  id: "drug-phytomenadione-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "phytomenadione-iv",
  label: "Phytomenadione (Vitamin K1) IV — VKDB / Warfarin Reversal",
  keywords: ["phytomenadione", "vitamin k", "iv", "vkdb", "warfarin reversal", "0.3 mg/kg", "konakion", "never rapid bolus", "anaphylaxis"],
  description: "0.3 mg/kg IV over 20–30 min (max 10 mg). NEVER rapid IV bolus — anaphylaxis risk",
},

// ─── RENAL / HYPERKALAEMIA ─────────────────────────────────────────────────
{
  id: "drug-insulin-dextrose-hyperk", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "insulin-dextrose-hyperk",
  label: "Insulin + Dextrose — Acute Hyperkalaemia",
  keywords: ["insulin dextrose", "hyperkalaemia", "hyperkalemia", "transcellular shift", "0.1 units/kg", "actrapid", "d25", "d10", "30 min"],
  description: "0.1 units/kg actrapid + 0.5 g/kg dextrose IV over 30 min. Reduces K⁺ by 0.5–1.5 mEq/L",
},

// ─── GI / HEPATIC ──────────────────────────────────────────────────────────
{
  id: "drug-pantoprazole-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "pantoprazole-iv",
  label: "Pantoprazole IV — GI Bleeding / Stress Ulcer Prophylaxis",
  keywords: ["pantoprazole", "iv", "gi bleeding", "pud", "stress ulcer", "1 mg/kg", "pantop iv", "ppi"],
  description: "0.5–1 mg/kg IV OD-BD (max 40 mg). GI bleed: 1 mg/kg bolus then 0.1–0.2 mg/kg/hr × 72 hr",
},
{
  id: "drug-terlipressin", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "terlipressin",
  label: "Terlipressin — Variceal Bleeding / Hepatorenal Syndrome",
  keywords: ["terlipressin", "glypressin", "variceal bleeding", "hepatorenal syndrome", "portal hypertension", "0.01 mg/kg", "splanchnic"],
  description: "0.01–0.02 mg/kg IV q4–6h (max 2 mg). Vasopressin analogue — reduces portal pressure",
},
{
  id: "drug-lactulose", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "lactulose",
  label: "Lactulose — Hepatic Encephalopathy / Constipation",
  keywords: ["lactulose", "duphalac", "hepatic encephalopathy", "constipation", "ammonia", "0.5 mL/kg", "2 stools per day"],
  description: "Hepatic encephalopathy: 0.5 mL/kg TDS (target 2–3 soft stools/day). PR retention enema option",
},

// ─── OTHER IV ANTIBIOTICS (new to drugs.js) ────────────────────────────────
{
  id: "drug-ampicillin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "ampicillin-iv",
  label: "Ampicillin IV — Neonatal Sepsis / Meningitis",
  keywords: ["ampicillin", "iv", "neonatal sepsis", "meningitis", "group b strep", "listeria", "50 mg/kg", "who etat"],
  description: "Sepsis: 50 mg/kg q6h. Meningitis: 100 mg/kg q6h. Neonates: q12h (≤7d) / q8h (8–28d)",
},
{
  id: "drug-cloxacillin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "cloxacillin-iv",
  label: "Cloxacillin IV — MSSA / Osteomyelitis / Endocarditis",
  keywords: ["cloxacillin", "iv", "mssa", "osteomyelitis", "septic arthritis", "endocarditis", "25 mg/kg", "antistaphylococcal"],
  description: "25–50 mg/kg/dose q6h (max 2 g). Drug of choice for MSSA infections",
},
{
  id: "drug-linezolid-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "linezolid-iv",
  label: "Linezolid IV — MRSA / VRE / MDR Gram-positive",
  keywords: ["linezolid", "iv", "mrsa", "vre", "mdr gram positive", "10 mg/kg", "zyvox", "lizolid", "serotonin syndrome"],
  description: "10 mg/kg IV/PO q8h (<12 yr). 100% bioavailability — switch to PO early. Max 2 weeks",
},
{
  id: "drug-amikacin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "amikacin-iv",
  label: "Amikacin IV — MDR Gram-negative / Neonatal Sepsis",
  keywords: ["amikacin", "iv", "mdr gram negative", "gentamicin resistant", "neonatal sepsis", "15 mg/kg", "amikin", "mikacin"],
  description: "15–20 mg/kg OD. Neonates: 15 mg/kg q24–48h. Target peak 20–30, trough <5 mcg/mL",
},
{
  id: "drug-colistin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "colistin-iv",
  label: "Colistin IV — XDR/PDR Acinetobacter / Pseudomonas (LAST RESORT)",
  keywords: ["colistin", "iv", "xdr", "pdr", "acinetobacter", "pseudomonas", "klebsiella", "last resort", "nephrotoxic", "2.5 mg/kg"],
  description: "Load 5 mg/kg CBA IV once. Maintenance 2.5 mg/kg q12h. LAST RESORT. Nephrotoxic 30–50%",
},
{
  id: "drug-cefoperazone-sulbactam", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "cefoperazone-sulbactam",
  label: "Cefoperazone-Sulbactam — MDR Gram-negative / Acinetobacter",
  keywords: ["cefoperazone sulbactam", "sulperazone", "magnamycin", "acinetobacter", "mdr gram negative", "biliary sepsis", "40 mg/kg"],
  description: "40–80 mg/kg q12h. Severe: q8–6h. Monitor PT/INR — vitamin K antagonism",
},
{
  id: "drug-teicoplanin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "teicoplanin-iv",
  label: "Teicoplanin IV/IM — MRSA / Resistant Gram-positive",
  keywords: ["teicoplanin", "targocid", "iv", "mrsa", "gram positive", "10 mg/kg", "less nephrotoxic", "od dosing"],
  description: "Load 10 mg/kg q12h × 3 doses then 6–10 mg/kg OD. Less nephrotoxic than vancomycin",
},
{
  id: "drug-fluconazole-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "fluconazole-iv",
  label: "Fluconazole IV — Invasive Candidiasis / Prophylaxis",
  keywords: ["fluconazole", "iv", "candidiasis", "candida", "forcan", "12 mg/kg", "loading dose", "antifungal"],
  description: "Load 12 mg/kg day 1 then 6–12 mg/kg OD (max 800 mg). 100% oral bioavailability — switch PO early",
},
{
  id: "drug-voriconazole-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "voriconazole-iv",
  label: "Voriconazole IV — Invasive Aspergillosis",
  keywords: ["voriconazole", "vfend", "aspergillosis", "invasive fungal", "9 mg/kg", "tdm", "trough", "photosensitivity"],
  description: "Load 9 mg/kg q12h × 2 doses, then 8 mg/kg q12h. TDM target trough 1–5.5 mcg/mL",
},
{
  id: "drug-micafungin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "micafungin-iv",
  label: "Micafungin IV — Invasive Candidiasis / HSCT Prophylaxis",
  keywords: ["micafungin", "mycamine", "echinocandin", "candida", "hsct", "2 mg/kg", "prophylaxis", "renal safe"],
  description: "Candidaemia: 2 mg/kg OD (max 100 mg). Neonates: 10 mg/kg OD. Safe in renal/hepatic impairment",
},
{
  id: "drug-ganciclovir-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "ganciclovir-iv",
  label: "Ganciclovir IV — CMV Disease / Congenital CMV",
  keywords: ["ganciclovir", "cymevene", "cmv", "cytomegalovirus", "retinitis", "congenital cmv", "5 mg/kg", "neutropenia"],
  description: "Induction: 5 mg/kg q12h × 14–21 days. Congenital CMV: 6 mg/kg q12h × 6 wk. Monitor FBC weekly",
},
{
  id: "drug-cefotaxime-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "cefotaxime-iv",
  label: "Cefotaxime IV — Sepsis / Meningitis / Neonatal",
  keywords: ["cefotaxime", "claforan", "taxim", "iv", "sepsis", "meningitis", "neonatal", "50 mg/kg", "preferred neonates"],
  description: "Sepsis: 50 mg/kg q8h. Meningitis: 75 mg/kg q6h. Preferred over ceftriaxone in neonates",
},
{
  id: "drug-quinine-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "quinine-iv",
  label: "Quinine IV — Severe Malaria (Artesunate Unavailable)",
  keywords: ["quinine", "iv", "severe malaria", "falciparum", "20 mg/kg", "qt prolongation", "hypoglycaemia", "artesunate unavailable"],
  description: "Load 20 mg/kg in NS over 4 hr then 10 mg/kg q8h. Monitor ECG, glucose. Never IV push",
},
{
  id: "drug-amphotericin-iv", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "amphotericin-b-iv",
  label: "Amphotericin B IV — Invasive Fungal / Kala-azar",
  keywords: ["amphotericin", "ambisome", "liposomal", "invasive fungal", "kala azar", "visceral leishmaniasis", "0.5 mg/kg", "electrolyte monitoring"],
  description: "Conventional: 0.5–1 mg/kg/day. Liposomal: 3–5 mg/kg/day. Monitor K⁺, Mg²⁺, creatinine daily",
},
{
  id: "drug-oseltamivir", tab: "drugs", tabLabel: "Drugs",
  section: "Drug Doses", drugId: "oseltamivir",
  label: "Oseltamivir — Influenza A/B",
  keywords: ["oseltamivir", "tamiflu", "fluvir", "osiflu", "influenza", "75 mg", "within 48 hours", "prophylaxis"],
  description: ">40 kg: 75 mg BD × 5 days. Start within 48 hr. ICU: 150 mg BD considered",
},

  // ─── DRUGS — NEBULISED ──────────────────────────────────────────────────────
  {
    id: "drugs-nebs-salbutamol", tab: "drugs", tabLabel: "Drugs",
    section: "Nebulised Drugs", drugId: "salbutamol-neb",
    label: "Salbutamol Nebulised — Asthma / Bronchospasm",
    keywords: ["salbutamol", "albuterol", "nebulised", "bronchodilator", "saba", "asthma", "bronchospasm", "asthalin", "ventolin", "2.5 mg", "5 mg"],
    description: "<20 kg: 2.5 mg · ≥20 kg: 5 mg q20min × 3. MDI+spacer preferred for mild-moderate",
  },
  {
    id: "drugs-nebs-adrenaline", tab: "drugs", tabLabel: "Drugs",
    section: "Nebulised Drugs", drugId: "adrenaline-neb",
    label: "Nebulised Adrenaline — Croup / Post-extubation Stridor",
    keywords: ["nebulised adrenaline", "neb adrenaline", "croup", "stridor", "1:1000", "0.5 mL/kg", "rebound stridor", "post extubation"],
    description: "0.5 mL/kg of 1:1000 (max 5 mL). Observe ≥2–4 hr for rebound stridor",
  },
  {
    id: "drugs-nebs-ipratropium", tab: "drugs", tabLabel: "Drugs",
    section: "Nebulised Drugs", drugId: "ipratropium-neb",
    label: "Ipratropium Bromide Nebulised — Moderate-Severe Asthma",
    keywords: ["ipratropium", "sama", "duolin", "ipravent", "moderate asthma", "severe asthma", "anticholinergic", "q20 min"],
    description: "<5 yr: 250 mcg · ≥5 yr: 500 mcg. Add to salbutamol for first 1–2 hr",
  },
  {
    id: "drugs-nebs-budesonide", tab: "drugs", tabLabel: "Drugs",
    section: "Nebulised Drugs", drugId: "budesonide-neb",
    label: "Budesonide Nebulised — Croup",
    keywords: ["budesonide", "pulmicort", "budecort", "croup", "ics", "2 mg", "subglottic oedema"],
    description: "Croup: 2 mg single dose (= 0.6 mg/kg dexamethasone PO)",
  },
  {
    id: "drugs-nebs-spacer", tab: "drugs", tabLabel: "Drugs",
    section: "Nebulised Drugs", drugId: null,
    label: "Spacer & MDI Technique by Age",
    keywords: ["spacer", "mdi", "inhaler", "aerochamber", "volumatic", "babyhaler", "mask", "mouthpiece", "technique"],
    description: "Spacer selection 0–2 yr / 2–6 yr / 6+ yr. MDI+spacer equivalent to nebuliser",
  },

  // ─── NEW ENTRIES TO ADD TO SEARCH_INDEX ────────────────────────────────────
// Add these after the existing "Nebulised Drugs" entries and before the
// "SYRUP CALCULATOR" section.
// ─────────────────────────────────────────────────────────────────────────────

  // ─── DRUGS — PER RECTAL ────────────────────────────────────────────────────
  {
    id: "drug-pr-diazepam", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "diazepam-pr",
    label: "Diazepam PR — Acute Seizure / Febrile Convulsion",
    keywords: ["diazepam", "pr", "per rectal", "rectal", "seizure", "febrile convulsion", "febrile seizure", "0.5 mg/kg", "no iv", "calmpose", "valium", "rectal diazepam"],
    description: "0.5 mg/kg PR (max 10 mg). IV solution used rectally. Onset 5–10 min. Hold buttocks 1–2 min",
  },
  {
    id: "drug-pr-midazolam", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "midazolam-pr",
    label: "Midazolam PR — Acute Seizure (Alternative)",
    keywords: ["midazolam", "pr", "per rectal", "rectal midazolam", "seizure", "0.4 mg/kg", "no iv", "mezolam", "dormicum", "rectal benzodiazepine"],
    description: "0.3–0.5 mg/kg PR (max 10 mg). Less preferred than rectal diazepam. Onset 5–10 min",
  },
  {
    id: "drug-pr-paraldehyde", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "paraldehyde-pr",
    label: "Paraldehyde PR — Refractory Status Epilepticus",
    keywords: ["paraldehyde", "pr", "per rectal", "rectal", "refractory seizure", "status epilepticus", "0.4 mL/kg", "arachis oil", "glass syringe", "resource limited"],
    description: "0.4 mL/kg PR mixed 1:1 with arachis oil (max 8 mL). MUST use glass syringe. Onset 15–30 min",
  },
  {
    id: "drug-pr-paracetamol", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "paracetamol-pr",
    label: "Paracetamol Suppository — Fever / Pain",
    keywords: ["paracetamol", "suppository", "pr", "per rectal", "fever", "pain", "vomiting", "calpol suppository", "metacin suppository", "15 mg/kg", "rectal paracetamol"],
    description: "15–20 mg/kg PR (max 1 g). Calpol suppositories 125/250/500 mg. Onset 30–60 min",
  },
  {
    id: "drug-pr-indomethacin", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "indomethacin-pr",
    label: "Indomethacin Suppository — Pain / Fever",
    keywords: ["indomethacin", "indocap", "suppository", "pr", "per rectal", "nsaid", "pain", "fever", "older children"],
    description: "1.5–3 mg/kg/day PR ÷ TDS (max 50 mg/dose). Indocap-25/50 suppositories",
  },
  {
    id: "drug-pr-promethazine", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "promethazine-pr",
    label: "Promethazine Suppository — Vomiting (>2 yr only)",
    keywords: ["promethazine", "phenergan", "suppository", "pr", "per rectal", "vomiting", "antiemetic", ">2 years", "0.75 mg/kg", "contraindicated infants"],
    description: "0.5–1 mg/kg PR (max 25 mg). CONTRAINDICATED <2 yr — fatal respiratory depression",
  },
  {
    id: "drug-pr-bisacodyl", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "bisacodyl-pr",
    label: "Bisacodyl Suppository — Constipation",
    keywords: ["bisacodyl", "dulcolax", "suppository", "pr", "per rectal", "constipation", "laxative", "5 mg", "10 mg", "bowel preparation"],
    description: "<10 kg: 5 mg OD · ≥10 kg: 10 mg OD. Onset 15–60 min. Dulcolax widely available India",
  },
  {
    id: "drug-pr-sodium-phosphate-enema", tab: "drugs", tabLabel: "Drugs",
    section: "Per Rectal", drugId: "sodium-phosphate-enema",
    label: "Sodium Phosphate Enema — Faecal Impaction",
    keywords: ["sodium phosphate enema", "fleet enema", "relaxyl enema", "pr", "per rectal", "constipation", "faecal impaction", "bowel preparation", "2.5 mL/kg", "phosphate"],
    description: "2.5 mL/kg (max 133 mL). Relaxyl enema available India. Avoid in renal impairment",
  },

  // ─── DRUGS — INTRANASAL ────────────────────────────────────────────────────
  {
    id: "drug-in-fentanyl", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "fentanyl-in",
    label: "Fentanyl IN — Acute Pain Without IV Access",
    keywords: ["fentanyl", "intranasal", "in", "nasal", "acute pain", "trauma", "fracture", "1.5 mcg/kg", "mad atomiser", "no iv", "opioid nasal"],
    description: "1.5–2 mcg/kg IN via MAD (max 100 mcg). Use 100 mcg/mL. Max 0.5 mL/nostril. Onset 5–10 min",
  },
  {
    id: "drug-in-ketamine", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "ketamine-in",
    label: "Ketamine IN — Sub-dissociative Analgesia",
    keywords: ["ketamine", "intranasal", "in", "nasal", "sub dissociative", "analgesia", "1 mg/kg", "pre iv", "trauma pain", "mad atomiser", "50 mg/mL"],
    description: "1–2 mg/kg IN via MAD (max 75 mg). Use 50 mg/mL. Onset 5–10 min. Opioid-sparing",
  },
  {
    id: "drug-in-midazolam", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "midazolam-in",
    label: "Midazolam IN — Seizure / Procedural Anxiolysis",
    keywords: ["midazolam", "intranasal", "in", "nasal", "seizure", "no iv", "anxiolysis", "pre mri", "0.2 mg/kg", "mad atomiser", "5 mg/mL", "nasal burning", "mezolam"],
    description: "0.2–0.3 mg/kg IN via MAD (max 10 mg). Use 5 mg/mL undiluted. Onset 5–10 min",
  },
  {
    id: "drug-in-dexmedetomidine", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "dexmedetomidine-in",
    label: "Dexmedetomidine IN — MRI Sedation / Anxiolysis",
    keywords: ["dexmedetomidine", "intranasal", "in", "nasal", "mri sedation", "procedural sedation", "1 mcg/kg", "no respiratory depression", "mad atomiser", "dextomid", "precedex"],
    description: "1–2 mcg/kg IN via MAD (max 100 mcg). Onset 25–30 min. No resp depression. Ideal for MRI",
  },
  {
    id: "drug-in-naloxone", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "naloxone-in",
    label: "Naloxone IN — Opioid Overdose Without IV",
    keywords: ["naloxone", "intranasal", "in", "nasal", "opioid overdose", "reversal", "0.1 mg/kg", "no iv", "narcan nasal", "mad atomiser", "re narcotisation"],
    description: "0.1 mg/kg IN via MAD (max 2 mg). Use 1 mg/mL ampoule. Onset 2–5 min. May need repeat doses",
  },
  {
    id: "drug-in-diazepam", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "diazepam-in",
    label: "Diazepam IN — Not Preferred (Poor Bioavailability)",
    keywords: ["diazepam", "intranasal", "in", "nasal", "seizure", "poor bioavailability", "not recommended", "alternative", "0.25 mg/kg"],
    description: "NOT preferred IN — poor nasal bioavailability of Indian IV formulation. Use IN midazolam or PR diazepam instead",
  },
  {
    id: "drug-in-mupirocin", tab: "drugs", tabLabel: "Drugs",
    section: "Intranasal", drugId: "mupirocin-in",
    label: "Mupirocin 2% Nasal — MRSA Decolonisation",
    keywords: ["mupirocin", "bactroban nasal", "mupicin nasal", "mrsa", "decolonisation", "nasal ointment", "pre surgery", "bd 5 days"],
    description: "~0.5 cm each nostril BD × 5 days. MRSA decolonisation before surgery. Bactroban Nasal",
  },

  // ─── DRUGS — INTRAMUSCULAR ─────────────────────────────────────────────────
  {
    id: "drug-im-adrenaline", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "adrenaline-im",
    label: "Adrenaline IM 1:1000 — Anaphylaxis First Line",
    keywords: ["adrenaline", "epinephrine", "im", "intramuscular", "anaphylaxis", "1:1000", "0.01 mg/kg", "anterolateral thigh", "epipen", "first line", "allergy"],
    description: "0.01 mg/kg IM anterolateral thigh (max 0.5 mg). Repeat q5–15 min. No absolute contraindication",
  },
  {
    id: "drug-im-midazolam", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "midazolam-im",
    label: "Midazolam IM — Status Epilepticus / Pre-sedation",
    keywords: ["midazolam", "im", "intramuscular", "status epilepticus", "seizure", "0.2 mg/kg", "no iv", "rampart", "prehospital", "mezolam"],
    description: "0.2 mg/kg IM (max 10 mg). RAMPART trial: equivalent to IV lorazepam for SE. Onset 5–10 min",
  },
  {
    id: "drug-im-diazepam-not-recommended", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "diazepam-im",
    label: "Diazepam IM — NOT Recommended (Erratic Absorption)",
    keywords: ["diazepam", "im", "intramuscular", "not recommended", "erratic absorption", "avoid", "use pr instead", "calmpose"],
    description: "IM diazepam NOT recommended — erratic absorption. Use PR diazepam or IM midazolam instead",
  },
  {
    id: "drug-im-ceftriaxone", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "ceftriaxone-im",
    label: "Ceftriaxone IM — Sepsis / Meningitis / Enteric Fever",
    keywords: ["ceftriaxone", "im", "intramuscular", "sepsis", "meningitis", "enteric fever", "pneumonia", "50 mg/kg", "monocef", "rocephin", "lignocaine reconstitution", "outpatient"],
    description: "50 mg/kg IM OD (max 2 g). Reconstitute in 1% lignocaine. Max 1 g per site",
  },
  {
    id: "drug-im-benzylpenicillin", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "benzylpenicillin-im",
    label: "Benzylpenicillin IM — Meningococcal / Pre-transfer",
    keywords: ["benzylpenicillin", "crystalline penicillin", "penicillin g", "im", "intramuscular", "meningococcal", "pre transfer", "50000 units/kg", "crystapen", "purpuric rash"],
    description: "50,000 units/kg IM stat (max 2.4 MU). Critical pre-transfer dose for suspected meningococcal disease",
  },
  {
    id: "drug-im-procaine-penicillin", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "procaine-penicillin-im",
    label: "Benzathine / Procaine Penicillin IM — RF Prophylaxis",
    keywords: ["benzathine penicillin", "procaine penicillin", "penidure", "im", "intramuscular", "rheumatic fever", "prophylaxis", "1.2 mu", "600000 units", "aspirate", "hoigne syndrome", "never iv"],
    description: "<30 kg: 600,000 units · ≥30 kg: 1.2 MU IM. ALWAYS aspirate — IV injection is fatal (Hoigne syndrome)",
  },
  {
    id: "drug-im-gentamicin", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "gentamicin-im",
    label: "Gentamicin IM — Gram-negative / Neonatal Sepsis",
    keywords: ["gentamicin", "im", "intramuscular", "gram negative", "neonatal sepsis", "7.5 mg/kg", "aminoglycoside", "once daily", "genticyn", "ototoxicity", "nephrotoxicity"],
    description: "7.5 mg/kg IM OD (children). Neonates: 4–5 mg/kg OD. Monitor levels if >5 days",
  },
  {
    id: "drug-im-ketorolac", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "ketorolac-im",
    label: "Ketorolac IM — Moderate-Severe Pain / Renal Colic",
    keywords: ["ketorolac", "toradol", "ketanov", "im", "intramuscular", "nsaid", "pain", "renal colic", "0.5 mg/kg", "30 mg", "max 5 days"],
    description: "0.5 mg/kg IM (max 30 mg). Comparable to morphine 10 mg. Max 5 days total",
  },
  {
    id: "drug-im-ondansetron", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "ondansetron-im",
    label: "Ondansetron IM — Severe Vomiting Without IV",
    keywords: ["ondansetron", "im", "intramuscular", "vomiting", "nausea", "0.1 mg/kg", "emeset", "ondem", "zofran", "off label im", "gastroenteritis"],
    description: "0.1–0.15 mg/kg IM (max 8 mg). Off-label but widely practiced India. Onset 20–30 min",
  },
  {
    id: "drug-im-dexamethasone", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "dexamethasone-im",
    label: "Dexamethasone IM — Croup / Severe Allergy",
    keywords: ["dexamethasone", "im", "intramuscular", "croup", "severe allergy", "0.6 mg/kg", "dexona", "decadron", "single dose", "cerebral oedema"],
    description: "0.6 mg/kg IM (croup, max 10 mg). Single dose sufficient — duration 36–72 hr",
  },
  {
    id: "drug-im-morphine", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "morphine-im",
    label: "Morphine IM — Severe Pain",
    keywords: ["morphine", "im", "intramuscular", "severe pain", "fracture", "burns", "0.1 mg/kg", "schedule x", "narcotic", "naloxone", "opioid"],
    description: "0.1–0.15 mg/kg IM (max 10 mg). Schedule X — special prescription required. Have naloxone ready",
  },
  {
    id: "drug-im-vitamin-k", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "vitamin-k-im",
    label: "Vitamin K1 IM — Neonatal Prophylaxis / VKDB",
    keywords: ["vitamin k", "phytomenadione", "im", "intramuscular", "neonatal prophylaxis", "vkdb", "konakion", "1 mg", "at birth", "warfarin reversal", "haemorrhage"],
    description: "Neonates: 1 mg IM at birth (0.5 mg if <1.5 kg). Konakion MM preferred. IV bolus → anaphylaxis risk",
  },
  {
    id: "drug-im-glucagon", tab: "drugs", tabLabel: "Drugs",
    section: "Intramuscular", drugId: "glucagon-im",
    label: "Glucagon IM — Severe Hypoglycaemia Without IV",
    keywords: ["glucagon", "glucagen", "im", "intramuscular", "hypoglycaemia", "unconscious", "no iv", "0.5 mg", "1 mg", "t1dm", "glycogenolysis", "hypokit"],
    description: "<25 kg: 0.5 mg IM · ≥25 kg: 1 mg IM. GlucaGen HypoKit. Lateral position — vomiting common",
  },
  // ─── SYRUP CALCULATOR (one per drug) ──────────────────────────────────────
  {
    id: "syrup-amoxicillin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "amoxicillin-oral",
    label: "Amoxicillin Syrup",
    keywords: ["amoxicillin", "novamox", "mox", "amoxil", "syrup", "suspension", "pneumonia", "aom", "pharyngitis", "uti", "30 mg/kg"],
    description: "30 mg/kg TDS (max 500 mg). Mox-125: 25 mg/mL · Mox-250: 50 mg/mL",
  },
  {
    id: "syrup-amoxiclav", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "amoxiclav-oral",
    label: "Amoxicillin-Clavulanate (Co-amoxiclav) Syrup",
    keywords: ["amoxicillin clavulanate", "co amoxiclav", "augmentin", "moxclav", "clavam", "syrup", "aom", "sinusitis", "animal bite", "45 mg/kg"],
    description: "45 mg/kg/day BD (max 875 mg). Augmentin-228 DS: 40 mg/mL",
  },
  {
    id: "syrup-cloxacillin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "cloxacillin-oral",
    label: "Cloxacillin Syrup — MSSA / Skin",
    keywords: ["cloxacillin", "klox", "bioclox", "mssa", "impetigo", "cellulitis", "empty stomach"],
    description: "25 mg/kg QID (max 500 mg). MUST give on EMPTY STOMACH",
  },
  {
    id: "syrup-cefixime", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "cefixime-oral",
    label: "Cefixime Syrup",
    keywords: ["cefixime", "taxim-o", "zifi", "cefix", "topcef", "syrup", "uti", "typhoid", "aom", "8 mg/kg"],
    description: "8 mg/kg/day OD or BD (max 400 mg). Taxim-O 50: 10 mg/mL",
  },
  {
    id: "syrup-cefpodoxime", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "cefpodoxime-oral",
    label: "Cefpodoxime Syrup",
    keywords: ["cefpodoxime", "cepodem", "cefoprox", "vantin", "syrup", "aom", "uti", "5 mg/kg"],
    description: "5 mg/kg BD (max 200 mg). Take WITH food",
  },
  {
    id: "syrup-cefuroxime", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "cefuroxime-oral",
    label: "Cefuroxime Axetil Syrup",
    keywords: ["cefuroxime", "ceftin", "supacef", "zocef", "syrup", "aom", "pneumonia", "animal bite", "15 mg/kg"],
    description: "15 mg/kg BD (max 500 mg). MUST give with food",
  },
  {
    id: "syrup-azithromycin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "azithromycin-oral",
    label: "Azithromycin Syrup",
    keywords: ["azithromycin", "azithral", "azee", "zithromax", "syrup", "atypical", "pneumonia", "pertussis", "scrub typhus", "macrolide", "10 mg/kg"],
    description: "10 mg/kg day 1 (max 500 mg) then 5 mg/kg days 2–5",
  },
  {
    id: "syrup-azithromycin-typhoid", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "azithromycin-typhoid",
    label: "Azithromycin High-Dose — Typhoid / Enteric Fever",
    keywords: ["azithromycin", "typhoid", "enteric fever", "azithral", "20 mg/kg", "high dose", "esbl salmonella"],
    description: "20 mg/kg OD × 7 days (max 1 g/day). IAP 2024 first-line for uncomplicated enteric fever",
  },
  {
    id: "syrup-clarithromycin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "clarithromycin-oral",
    label: "Clarithromycin Syrup",
    keywords: ["clarithromycin", "claribid", "klaricid", "biaxin", "syrup", "atypical pneumonia", "h pylori", "pertussis"],
    description: "7.5 mg/kg BD (max 500 mg). H. pylori triple therapy. Give with food",
  },
  {
    id: "syrup-metronidazole", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "metronidazole-oral",
    label: "Metronidazole Syrup — Amoeba / Giardia",
    keywords: ["metronidazole", "flagyl", "metrogyl", "aldezole", "syrup", "amoebiasis", "giardia", "anaerobic"],
    description: "7.5 mg/kg TDS (max 400 mg). Amoebiasis: 10 mg/kg TDS × 10 days",
  },
  {
    id: "syrup-cotrimoxazole", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "cotrimoxazole-oral",
    label: "Co-trimoxazole (TMP-SMX) Syrup",
    keywords: ["cotrimoxazole", "bactrim", "septran", "tmp smx", "uti", "pcp prophylaxis", "shigella"],
    description: "4–6 mg/kg TMP BD (max 160 mg TMP). PCP prophylaxis: 5 mg/kg TMP OD 3×/week",
  },
  {
    id: "syrup-isoniazid", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "isoniazid-oral",
    label: "Isoniazid (INH) Syrup — TB",
    keywords: ["isoniazid", "inh", "tb", "tuberculosis", "ltbi", "10 mg/kg", "isokin"],
    description: "10 mg/kg OD (max 300 mg). LTBI: 10 mg/kg OD × 6 months. Add pyridoxine",
  },
  {
    id: "syrup-fluconazole", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "fluconazole-oral",
    label: "Fluconazole Syrup — Candidiasis",
    keywords: ["fluconazole", "forcan", "syscan", "zocon", "thrush", "candida", "antifungal", "6 mg/kg"],
    description: "6–12 mg/kg OD (max 400 mg). Thrush: 3 mg/kg OD × 7 days",
  },
  {
    id: "syrup-albendazole", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "albendazole-oral",
    label: "Albendazole Syrup — Helminths / Worms",
    keywords: ["albendazole", "zentel", "bandy", "noworm", "helminths", "worms", "deworming", "400 mg"],
    description: "Helminths: 400 mg single dose (>10 kg). NCC: 15 mg/kg BD × 4 weeks",
  },
  {
    id: "syrup-acyclovir-oral", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "acyclovir-oral",
    label: "Acyclovir Syrup — Varicella / Herpes",
    keywords: ["acyclovir", "zovirax", "acivir", "varicella", "chickenpox", "herpes", "20 mg/kg"],
    description: "Varicella: 20 mg/kg QID × 5 days (max 800 mg/dose)",
  },
  {
    id: "syrup-chloroquine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "chloroquine-oral",
    label: "Chloroquine Syrup — P. vivax Malaria",
    keywords: ["chloroquine", "lariago", "malarex", "vivax", "malaria", "10 mg/kg"],
    description: "10 mg base/kg D1–2, then 5 mg base/kg D3. Plus primaquine for radical cure",
  },
  {
    id: "syrup-primaquine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "primaquine-oral",
    label: "Primaquine — P. vivax Radical Cure",
    keywords: ["primaquine", "vivax", "radical cure", "g6pd", "0.25 mg/kg", "malaria", "14 days"],
    description: "0.25 mg/kg OD × 14 days. G6PD screen MANDATORY before starting",
  },
  {
    id: "syrup-paracetamol", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Analgesic", drugId: "paracetamol-oral",
    label: "Paracetamol Syrup — Fever / Pain",
    keywords: ["paracetamol", "acetaminophen", "calpol", "metacin", "dolo", "syrup", "fever", "pain", "15 mg/kg"],
    description: "15 mg/kg q4–6h (max 1 g/dose). Calpol-120: 24 mg/mL · Calpol-250: 50 mg/mL",
  },
  {
    id: "syrup-ibuprofen", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Analgesic", drugId: "ibuprofen-oral",
    label: "Ibuprofen Syrup — Fever / Pain",
    keywords: ["ibuprofen", "brufen", "ibugesic", "advil", "syrup", "fever", "pain", "nsaid", "10 mg/kg"],
    description: "10 mg/kg TDS (max 400 mg). Give with food. Avoid in dengue",
  },
  {
    id: "syrup-ondansetron", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antiemetic", drugId: "ondansetron-oral",
    label: "Ondansetron Syrup — Vomiting",
    keywords: ["ondansetron", "emeset", "ondem", "zofran", "vomikind", "syrup", "odt", "vomiting", "nausea", "0.15 mg/kg"],
    description: "0.15 mg/kg TDS (max 4 mg if <15 kg, 8 mg if ≥15 kg). ODT available",
  },
  {
    id: "syrup-domperidone", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antiemetic", drugId: "domperidone-oral",
    label: "Domperidone Syrup — Nausea / Vomiting / GERD",
    keywords: ["domperidone", "domstal", "motilium", "vomistop", "prokinetic", "gerd", "vomiting", "0.25 mg/kg"],
    description: "0.25–0.5 mg/kg TDS before meals (max 10 mg). Short duration",
  },
  {
    id: "syrup-zinc", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "ORS/Zinc", drugId: "zinc-oral",
    label: "Zinc — Diarrhoea Protocol",
    keywords: ["zinc", "diarrhoea", "ors", "oral rehydration", "20 mg", "10 mg", "zincovit", "pedizinc", "14 days"],
    description: "<6 mo: 10 mg OD · ≥6 mo: 20 mg OD × 14 days. Mandatory WHO/IAP protocol",
  },
  {
    id: "syrup-prednisolone", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Steroid", drugId: "prednisolone-oral",
    label: "Prednisolone Syrup — Asthma / Nephrotic",
    keywords: ["prednisolone", "omnacortil", "wysolone", "prelone", "syrup", "asthma", "nephrotic syndrome", "steroid", "1 mg/kg"],
    description: "Asthma: 1–2 mg/kg OD × 3–5 days. Nephrotic: 2 mg/kg OD × 6 weeks",
  },
  {
    id: "syrup-dexamethasone-oral", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Steroid", drugId: "dexamethasone-oral",
    label: "Dexamethasone Oral — Croup",
    keywords: ["dexamethasone", "croup", "dexona", "wymesone", "0.6 mg/kg", "single dose", "stridor"],
    description: "0.6 mg/kg single dose (max 10 mg). PO as effective as IM/IV for croup",
  },
  {
    id: "syrup-levetiracetam-oral", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Anticonvulsant", drugId: "levetiracetam-oral",
    label: "Levetiracetam Oral Solution — Epilepsy",
    keywords: ["levetiracetam", "keppra", "levipil", "oral solution", "seizure", "epilepsy", "10 mg/kg", "100 mg/mL"],
    description: "Start 10 mg/kg BD, increase to 30 mg/kg BD. Keppra 100 mg/mL oral solution",
  },
  {
    id: "syrup-valproate-oral", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Anticonvulsant", drugId: "valproate-oral",
    label: "Sodium Valproate Syrup — Epilepsy",
    keywords: ["valproate", "sodium valproate", "valparin", "encorate", "epilex", "syrup", "epilepsy", "absence", "10 mg/kg"],
    description: "10–15 mg/kg BD, increase to 20–40 mg/kg/day. AVOID <2 yr",
  },
  {
    id: "syrup-carbamazepine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Anticonvulsant", drugId: "carbamazepine-oral",
    label: "Carbamazepine Syrup — Focal Epilepsy",
    keywords: ["carbamazepine", "tegretol", "mazetol", "carbatol", "syrup", "focal epilepsy", "5 mg/kg"],
    description: "Start 5 mg/kg BD, titrate to 10–20 mg/kg/day. Check HLA-B*1502 (SJS risk)",
  },
  {
    id: "syrup-phenobarbitone", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Anticonvulsant", drugId: "phenobarbitone-oral",
    label: "Phenobarbitone Syrup — Epilepsy / Neonatal",
    keywords: ["phenobarbitone", "phenobarbital", "gardenal", "luminal", "syrup", "epilepsy", "neonatal seizures", "3 mg/kg"],
    description: "3–5 mg/kg OD. First-line for neonatal seizures. Give at bedtime",
  },
  {
    id: "syrup-clobazam", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Anticonvulsant", drugId: "clobazam-oral",
    label: "Clobazam Syrup — Adjunct Epilepsy",
    keywords: ["clobazam", "frisium", "cloba", "lobazam", "lennox gastaut", "refractory epilepsy", "0.3 mg/kg"],
    description: "0.3 mg/kg BD increasing to 1 mg/kg BD. Adjunct for refractory epilepsy",
  },
  {
    id: "syrup-midazolam-oral", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Sedation", drugId: "midazolam-oral",
    label: "Midazolam Oral — Pre-procedural Sedation",
    keywords: ["midazolam", "oral", "pre medication", "procedural sedation", "0.5 mg/kg", "anxiolysis", "pre op"],
    description: "0.5 mg/kg PO 20–30 min before procedure (max 15 mg). Mix in sweet juice",
  },
  {
    id: "syrup-triclofos", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Sedation", drugId: "Triclofos Sodium",
    label: "Triclofos (Pedicloryl) — Procedural Sedation",
    keywords: ["triclofos", "pedicloryl", "chloral", "oral sedation", "mri sedation", "syrup", "sedation", "eeg", "echo", "75 mg/kg", "50 mg/kg", "pediclix", "silence", "mitflos"],
    description: "Initial 80 mg/kg PO (max 1 g). Supplement 5 mg/kg q5min from 30 min. Duration 6–8 hr",
  },
  {
    id: "syrup-hydroxyzine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Sedation", drugId: "hydroxyzine-oral",
    label: "Hydroxyzine Syrup — Anxiolysis / Urticaria",
    keywords: ["hydroxyzine", "atarax", "vistaril", "syrup", "anxiolysis", "urticaria", "pruritus", "pre medication"],
    description: "0.5–1 mg/kg PO (max 50 mg). Also for urticaria, pruritus",
  },
  {
    id: "syrup-melatonin", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Sedation", drugId: "melatonin-oral",
    label: "Melatonin — Sleep Disorders / ASD",
    keywords: ["melatonin", "meloset", "melzap", "sleep disorder", "asd", "adhd", "insomnia", "circadian"],
    description: "Start 0.5–1 mg at bedtime; usual 1–5 mg. 30–60 min before sleep",
  },
  {
    id: "syrup-cetirizine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "cetirizine-oral",
    label: "Cetirizine Syrup — Allergic Rhinitis / Urticaria",
    keywords: ["cetirizine", "alerid", "zyrtec", "okacet", "syrup", "allergic rhinitis", "urticaria", "antihistamine"],
    description: "2–5 yr: 2.5 mg OD · 6–11 yr: 5 mg OD · ≥12 yr: 10 mg OD",
  },
  {
    id: "syrup-levocetirizine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "levocetirizine-oral",
    label: "Levocetirizine Syrup — Allergic Rhinitis",
    keywords: ["levocetirizine", "levorid", "xyzal", "levocet", "syrup", "allergic rhinitis", "urticaria"],
    description: "2–5 yr: 1.25 mg OD · 6–11 yr: 2.5 mg OD · ≥12 yr: 5 mg OD",
  },
  {
    id: "syrup-chlorpheniramine", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "chlorpheniramine-oral",
    label: "Chlorpheniramine (CPM) Syrup — Allergic Rhinitis",
    keywords: ["chlorpheniramine", "cpm", "piriton", "avil", "syrup", "allergic rhinitis", "urticaria", "sedating antihistamine"],
    description: "0.1 mg/kg TDS (max 4 mg). Sedating 1st gen — avoid in infants <2 yr",
  },
  {
    id: "syrup-montelukast", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "montelukast-oral",
    label: "Montelukast — Asthma Prophylaxis / Allergic Rhinitis",
    keywords: ["montelukast", "montek", "romilast", "singulair", "asthma", "allergic rhinitis", "post viral wheeze", "leukotriene"],
    description: "6–23 mo: 4 mg granules OD · 2–5 yr: 4 mg OD · 6–14 yr: 5 mg OD · ≥15 yr: 10 mg OD",
  },
  {
    id: "syrup-iron", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "iron-oral",
    label: "Elemental Iron Drops/Syrup — Iron Deficiency Anaemia",
    keywords: ["iron", "elemental iron", "anaemia", "pediron", "orofer", "feronia", "3 mg/kg", "iron deficiency"],
    description: "Therapeutic: 3–6 mg/kg elemental iron OD. Take between meals",
  },
  {
    id: "syrup-vitamin-d", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Other", drugId: "vitamin-d-oral",
    label: "Vitamin D3 — Deficiency / Rickets",
    keywords: ["vitamin d", "cholecalciferol", "d3", "rickets", "deficiency", "d-rise", "uprise", "400 iu", "60000 iu"],
    description: "Prevention: 400 IU/day. Deficiency: 2000–4000 IU/day × 12 weeks",
  },
  {
    id: "syrup-ors", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Fluids / ORS", drugId: "ors-oral",
    label: "WHO-ORS — Oral Rehydration Salts",
    keywords: ["ors", "oral rehydration", "electral", "pedialyte", "diarrhoea", "dehydration", "rehydration"],
    description: "Mild: 50 mL/kg/4hr · Moderate: 100 mL/kg/4hr. Mandatory with zinc",
  },
  {
    id: "syrup-linezolid", tab: "syrup", tabLabel: "Syrup Calculator",
    section: "Antibiotic", drugId: "linezolid-oral",
    label: "Linezolid Oral — MRSA / VRE",
    keywords: ["linezolid", "lizolid", "zyvox", "mrsa", "vre", "mdr tb", "10 mg/kg", "oral bioavailability"],
    description: "<12 yr: 10 mg/kg TDS (max 600 mg). 100% oral bioavailability — switch IV early",
  },

  // ─── SEDATION & ANALGESIA TAB ──────────────────────────────────────────────
  {
    id: "sed-ketamine-psa", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Ketamine — PSA",
    keywords: ["ketamine", "psa", "procedural sedation", "dissociative", "1-2 mg/kg", "im", "4 mg/kg", "ed sedation"],
    description: "1–2 mg/kg IV or 4–5 mg/kg IM. First-line ED PSA. Bronchodilator",
  },
  {
    id: "sed-propofol-psa", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Propofol — PSA / Brief Procedures",
    keywords: ["propofol", "psa", "brief procedures", "cardioversion", "imaging", "hypotension", "apnoea"],
    description: "1–2 mg/kg IV. No analgesia. Hypotension risk. Antiemetic effect",
  },
  {
    id: "sed-midazolam-psa", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Midazolam — PSA / Anxiolysis",
    keywords: ["midazolam", "psa", "anxiolysis", "0.05 mg/kg", "in midazolam", "buccal", "flumazenil"],
    description: "0.05–0.1 mg/kg IV · 0.2 mg/kg IN · 0.3 mg/kg buccal. Reversible",
  },
  {
    id: "sed-fentanyl-psa", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Fentanyl — Analgesia / PSA",
    keywords: ["fentanyl", "psa", "analgesia", "1 mcg/kg", "in fentanyl", "chest wall rigidity", "naloxone"],
    description: "1–2 mcg/kg IV slow · 1.5 mcg/kg IN. Rapid analgesia. Reversible with naloxone",
  },
  {
    id: "sed-ketofol", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Ketofol — Combined Sedation",
    keywords: ["ketofol", "ketamine propofol", "1:1", "combination sedation", "psa"],
    description: "0.5–1 mg/kg of 1:1 mixture IV. Balances haemodynamics and emergence",
  },
  {
    id: "sed-dexmedetomidine-psa", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Dexmedetomidine — MRI / ICU / No Resp Depression",
    keywords: ["dexmedetomidine", "mri sedation", "icu sedation", "alpha2", "no respiratory depression", "brady", "precedex"],
    description: "Load 0.5–1 mcg/kg over 10 min, then 0.2–0.7 mcg/kg/hr. No resp depression",
  },
  {
    id: "sed-nitrous", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Nitrous Oxide 50:50 — Minor Procedures",
    keywords: ["nitrous oxide", "entonox", "n2o", "self administered", "procedural", "iv cannula", "dressing"],
    description: "Self-administered inhalation. ≥5 yr cooperative. Offset in 5 min",
  },
  {
    id: "sed-etomidate-psa", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Agents", label: "Etomidate — RSI Haemodynamically Unstable",
    keywords: ["etomidate", "rsi", "haemodynamically unstable", "0.3 mg/kg", "myoclonus"],
    description: "0.3 mg/kg IV. Haemodynamically neutral RSI induction",
  },
  {
    id: "sed-triclofos-sedation", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "Oral Sedation", label: "Triclofos — Oral Sedation MRI/EEG",
    keywords: ["triclofos", "pedicloryl", "oral sedation", "mri sedation", "eeg", "echo", "50 mg/kg", "75 mg/kg"],
    description: "50–75 mg/kg PO (max 1000 mg). Onset 20–40 min. Duration 6–8 hr",
  },
  {
    id: "sed-midazolam-oral-sedation", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "Oral Sedation", label: "Midazolam Oral — Pre-procedural",
    keywords: ["midazolam oral", "oral pre med", "0.5 mg/kg", "anxiolysis", "premedication", "juice"],
    description: "0.3–0.6 mg/kg PO (max 15 mg) 20–30 min before procedure",
  },
  {
    id: "sed-dex-intranasal", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "Oral Sedation", label: "Dexmedetomidine Intranasal — MRI Pre-med",
    keywords: ["dexmedetomidine intranasal", "in dex", "mri premedication", "1-2 mcg/kg", "no respiratory depression", "mad"],
    description: "1–2 mcg/kg IN with MAD atomiser. Onset 30 min. Ideal for MRI, ECHO",
  },
  {
    id: "sed-local-anaesthetics", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "Local Anaesthetics", label: "Local Anaesthetic Safe Doses",
    keywords: ["local anaesthetic", "lignocaine", "lidocaine", "bupivacaine", "max dose", "toxicity", "last", "4.5 mg/kg", "2 mg/kg"],
    description: "Lignocaine max 4.5 mg/kg plain · Bupivacaine max 2 mg/kg. Never with epi for digits",
  },
  {
    id: "sed-nerve-blocks", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "Nerve Blocks", label: "Paediatric Nerve Blocks — FANSB / Digital / IITB",
    keywords: ["nerve block", "fascia iliaca", "femoral", "digital block", "intercostal", "scalp block", "wound infiltration", "ultrasound"],
    description: "FANSB, digital, fascia iliaca, intercostal. Aspirate q5 mL. Monitor for LAST",
  },
  {
    id: "sed-last", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "LAST", label: "LAST — Local Anaesthetic Systemic Toxicity",
    keywords: ["last", "local anaesthetic toxicity", "intralipid", "20% lipid emulsion", "cardiac arrest la", "seizure la", "tinnitus", "1.5 mL/kg"],
    description: "Intralipid 20%: 1.5 mL/kg bolus + 0.25–0.5 mL/kg/min infusion. Max 12 mL/kg",
  },
  {
    id: "sed-psa-principles", tab: "sedation", tabLabel: "Sedation & Analgesia",
    section: "PSA Principles", label: "PSA Pre / During / Post Procedure",
    keywords: ["psa principles", "pre procedure", "monitoring", "fasting", "npo", "discharge criteria", "post procedure"],
    description: "Pre: NPO, consent, monitoring setup. During: airway watch. Post: discharge criteria",
  },

  // ─── NEONATAL ──────────────────────────────────────────────────────────────
  {
    id: "neo-nrp", tab: "neonatal", tabLabel: "Neonatal",
    section: "NRP", label: "Neonatal Resuscitation (NRP 2020)",
    keywords: ["nrp", "neonatal resuscitation", "ppv", "positive pressure ventilation", "t-piece", "hr check", "delayed cord clamping", "delivery room"],
    description: "Delayed cord clamping ≥60 s · Initial FiO₂ 0.21 term · HR <60 → CPR 3:1",
  },
  {
    id: "neo-doses", tab: "neonatal", tabLabel: "Neonatal",
    section: "Doses", label: "Neonatal Drug Doses — Adrenaline / ETT / UVC",
    keywords: ["neonatal dose", "ett depth neonate", "uvc", "umbilical venous catheter", "adrenaline neonate", "phenobarbital neonate", "caffeine neonate"],
    description: "Adrenaline 0.01–0.03 mg/kg · ETT depth (6+wt) cm · UVC (1.5×wt+5.5) cm",
  },
  {
    id: "neo-apgar", tab: "neonatal", tabLabel: "Neonatal",
    section: "APGAR", label: "APGAR Score",
    keywords: ["apgar", "score", "newborn assessment", "tone", "grimace", "colour", "1 minute", "5 minutes"],
    description: "APGAR at 1 & 5 min. Score ≥7 normal · 4–6 moderate · <4 severe",
  },
  {
    id: "neo-stops", tab: "neonatal", tabLabel: "Neonatal",
    section: "STOPS", label: "STOPS — Neonatal Mortality Score",
    keywords: ["stops", "neonatal mortality", "prognosis", "sensorium", "temperature", "oxygenation", "perfusion", "sugar", "nicu score"],
    description: "STOPS score (0–10). Score >2 predicts mortality ~83%",
  },
  {
    id: "neo-vitals", tab: "neonatal", tabLabel: "Neonatal",
    section: "Vitals", label: "Neonatal Normal Vitals & SpO₂ Targets",
    keywords: ["neonatal vitals", "normal neonate", "neonatal heart rate", "neonatal rr", "spo2 targets nrp", "preductal", "postductal"],
    description: "HR 100–160, RR 40–60, SpO₂ targets: 1 min 60–65% → 10 min 85–95%",
  },
  {
    id: "neo-spo2-targets", tab: "neonatal", tabLabel: "Neonatal",
    section: "NRP", label: "Preductal SpO₂ Targets NRP",
    keywords: ["spo2 targets", "preductal", "nrp", "fio2", "right hand", "delivery room", "1 minute", "10 minute"],
    description: "1 min: 60–65% · 3 min: 70–75% · 5 min: 80–85% · 10 min: 85–95%",
  },

  // ─── TRAUMA ────────────────────────────────────────────────────────────────
  {
    id: "trauma-primary", tab: "trauma", tabLabel: "Trauma Resuscitation",
    section: "Primary Survey", label: "xABCDE Primary Survey — ATLS 2025",
    keywords: ["primary survey", "xabcde", "atls", "haemorrhage control", "tourniquet", "airway trauma", "c-spine", "mils", "tension pneumothorax", "fast"],
    description: "x = Exsanguinating haemorrhage first. ABCDE with simultaneous intervention",
  },
  {
    id: "trauma-shock", tab: "trauma", tabLabel: "Trauma Resuscitation",
    section: "Shock & Fluids", label: "Haemorrhagic Shock Classification",
    keywords: ["haemorrhagic shock", "class I II III IV", "blood loss", "ebv", "permissive hypotension", "blood products", "damage control", "mtp"],
    description: "Class I–IV. Blood products 1:1:1. Permissive hypotension until surgical control",
  },
  {
    id: "trauma-txa", tab: "trauma", tabLabel: "Trauma Resuscitation",
    section: "Shock & Fluids", label: "Tranexamic Acid (TXA) — Within 3 Hours",
    keywords: ["txa", "tranexamic acid", "15 mg/kg", "major haemorrhage", "trauma bleeding", "within 3 hours", "antifibrinolytic"],
    description: "TXA 15 mg/kg (max 1 g) IV over 10 min, then 2 mg/kg/hr × 8 hr. <3 hr",
  },
  {
    id: "trauma-tbi", tab: "trauma", tabLabel: "Trauma Resuscitation",
    section: "TBI", label: "TBI — GCS / ICP Management",
    keywords: ["tbi", "traumatic brain injury", "gcs", "intracranial pressure", "icp", "mannitol", "hypertonic saline", "herniation", "cushing triad"],
    description: "GCS ≤8 = severe. Osmotherapy: 3% NaCl 2–5 mL/kg or Mannitol 0.5 g/kg",
  },
  {
    id: "trauma-pecarn", tab: "trauma", tabLabel: "Trauma Resuscitation",
    section: "TBI", label: "PECARN CT Rule — Head Injury",
    keywords: ["pecarn", "head injury", "ct head", "citbi", "gcs 14", "scalp haematoma", "loss of consciousness", "basilar skull", "raccoon eyes"],
    description: "<2 yr: GCS ≤14, AMS, skull #, non-frontal haematoma. ≥2 yr: GCS ≤14, AMS, basilar #",
  },

  // ─── ALGORITHMS ────────────────────────────────────────────────────────────
  {
    id: "algo-septic-shock", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Septic Shock Algorithm",
    keywords: ["septic shock", "sepsis", "hour 1 bundle", "fluid bolus", "antibiotics", "norepinephrine", "lactate", "warm shock", "cold shock"],
    description: "Hour-1: 20 mL/kg bolus, cultures, antibiotics <1 hr, noradrenaline if fluid-refractory",
  },
  {
    id: "algo-anaphylaxis", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Anaphylaxis Algorithm",
    keywords: ["anaphylaxis", "adrenaline im", "epinephrine", "anterolateral thigh", "biphasic", "epipen", "allergy", "urticaria"],
    description: "Epi IM 0.01 mg/kg (max 0.5 mg) anterolateral thigh — ONLY life-saving drug. Repeat q5–15 min",
  },
  {
    id: "algo-dka", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "DKA Algorithm",
    keywords: ["dka", "diabetic ketoacidosis", "insulin", "cerebral oedema", "deficit 48 hours", "0.9% ns", "ispad", "iap dka"],
    description: "Deficit over 48 hr · Insulin after 1 hr fluids · Cerebral oedema: mannitol or 3% NaCl",
  },
  {
    id: "algo-status-epilepticus", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Status Epilepticus Algorithm",
    keywords: ["status epilepticus", "seizure", "midazolam in", "lorazepam", "levetiracetam", "phenytoin", "refractory", "iap 2021"],
    description: "0–5 min: midazolam IN · 5–20 min: lorazepam/LEV · 20–40 min: midazolam infusion",
  },
  {
    id: "algo-meningitis", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Bacterial Meningitis Algorithm",
    keywords: ["meningitis", "ceftriaxone", "dexamethasone", "csf", "lp", "bacterial", "iap 2019"],
    description: "Ceftriaxone 100 mg/kg + dexamethasone before/with 1st dose. LP if no raised ICP signs",
  },
  {
    id: "algo-asthma", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Acute Asthma Algorithm",
    keywords: ["asthma", "salbutamol", "ipratropium", "magnesium", "prednisolone", "dexamethasone", "severity", "silent chest"],
    description: "Salbutamol MDI q20min × 3 + systemic steroids. MgSO₄ for severe. IV salbut for critical",
  },
  {
    id: "algo-croup", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Croup Algorithm",
    keywords: ["croup", "dexamethasone", "nebulised adrenaline", "westley score", "stridor", "ltb", "barking cough"],
    description: "Dexamethasone 0.6 mg/kg PO all grades. Neb adrenaline for mod-severe. Obs 2–4 hr",
  },
  {
    id: "algo-dengue", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "ED Management", label: "Dengue Algorithm",
    keywords: ["dengue", "group a b c", "ns1", "plasma leakage", "haematocrit", "platelets", "warning signs", "dss"],
    description: "Group A outpatient · Group B IV fluids · Group C resuscitation. No NSAIDs/steroids",
  },
  {
    id: "algo-aha", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "AHA Algorithms", label: "AHA PALS 2025 Algorithms",
    keywords: ["pals", "aha", "2025", "cardiac arrest", "cpr", "shockable", "non shockable", "defibrillation", "rosc"],
    description: "Updated 2025 AHA PALS: CPR cadence, defibrillation, post-arrest care",
  },
  {
    id: "algo-guidelines", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "Clinical Guidelines", label: "IAP Clinical Guidelines 2019–2024",
    keywords: ["iap guidelines", "indian academy pediatrics", "asthma iap", "bronchiolitis iap", "sepsis iap", "dka iap", "dengue iap", "meningitis iap"],
    description: "IAP 2019–2024 key points for asthma, bronchiolitis, croup, SE, sepsis, DKA, dengue",
  },
  {
    id: "algo-pathways", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "Interactive Pathways", label: "Interactive Decision-Tree Pathways",
    keywords: ["pathway", "decision tree", "interactive", "asthma severity", "dehydration pathway", "febrile seizure", "bronchiolitis pathway", "care plan", "pdf"],
    description: "Click-through pathways with weight-based doses at endpoint. Export care plan PDF",
  },
  {
    id: "algo-differentials", tab: "algorithms", tabLabel: "Management Algorithms",
    section: "Differentials", label: "Differential Diagnosis — Wheeze, Stridor, Altered Consciousness",
    keywords: ["differential diagnosis", "ddx", "wheeze", "stridor", "altered consciousness", "rash", "abdominal pain", "limp", "red flags"],
    description: "Diagnosis tables by chief complaint with age, clues, workup, red flags",
  },

  // ─── PREHOSPITAL ───────────────────────────────────────────────────────────
  {
    id: "preh-triage", tab: "prehospital", tabLabel: "Prehospital",
    section: "Triage", label: "Prehospital Triage — AVPU & ABCDE",
    keywords: ["triage", "avpu", "alert", "voice", "pain", "unresponsive", "abcde prehospital", "prem"],
    description: "AVPU scale. PREM triangle: ABCDE rapid assessment with simultaneous intervention",
  },
  {
    id: "preh-bls", tab: "prehospital", tabLabel: "Prehospital",
    section: "BLS & CPR", label: "Basic Life Support & CPR",
    keywords: ["bls", "basic life support", "cpr", "rescue breathing", "chest compressions", "15:2"],
    description: "Check responsiveness, 2 rescue breaths, 15:2 CPR. Adrenaline q3–5 min IV/IO",
  },
  {
    id: "preh-choking", tab: "prehospital", tabLabel: "Prehospital",
    section: "Choking", label: "Choking — Heimlich / Back Blows",
    keywords: ["choking", "heimlich", "back blows", "chest thrusts", "foreign body airway", "infant choking"],
    description: "Child ≥1 yr: 5 abdominal thrusts. Infant <1 yr: 5 back blows + 5 chest thrusts",
  },
  {
    id: "preh-seizure", tab: "prehospital", tabLabel: "Prehospital",
    section: "Seizures", label: "Seizure First Aid — Midazolam IN/IM",
    keywords: ["seizure prehospital", "convulsion", "midazolam prehospital", "in midazolam", "febrile seizure", "recovery position"],
    description: "Recovery position, O₂, midazolam 0.2 mg/kg IM/IN/buccal",
  },
  {
    id: "preh-poison", tab: "prehospital", tabLabel: "Prehospital",
    section: "Poisoning", label: "Poisoning — Activated Charcoal & Antidotes",
    keywords: ["poisoning", "activated charcoal", "naloxone", "atropine organophosphate", "co poisoning", "corrosive", "antidote"],
    description: "Activated charcoal within 2 hr. CO → O₂. OP → atropine. Never induce vomiting",
  },
  {
    id: "preh-poison-centres", tab: "prehospital", tabLabel: "Prehospital",
    section: "Poison Centres", label: "Poison Information Centres India — 24 hr",
    keywords: ["poison centre", "poison control", "aiims poison", "1800-425-1213", "antidote guidance", "poison helpline"],
    description: "AIIMS: 011-26850691 · CMC Vellore: 1800-425-1213 (toll-free) · Amrita Kochi: 484-2858056",
  },
  {
    id: "preh-snakebite", tab: "prehospital", tabLabel: "Prehospital",
    section: "Envenomation", label: "Snake Bite — RIGHT Mnemonic / Scorpion Prazosin",
    keywords: ["snake bite", "right mnemonic", "asv", "antivenom", "tourniquet snake", "scorpion", "prazosin", "envenomation"],
    description: "Snake: Reassure · Immobilise · Get to hospital · Tell doctor. Scorpion: prazosin 30 mcg/kg",
  },
  {
    id: "preh-burns", tab: "prehospital", tabLabel: "Prehospital",
    section: "Burns", label: "Burns First Aid — Cool Running Water 20 min",
    keywords: ["burns first aid", "cool water", "tbsa estimation", "inhalation injury", "facial burns", "stridor burns"],
    description: "Cool running water 20 min within 30 min. No ice. Inhalation injury → early intubation",
  },

  // ─── IMMUNISATION ──────────────────────────────────────────────────────────
  {
    id: "imm-iap", tab: "immunisation", tabLabel: "Immunisation",
    section: "IAP Schedule", label: "IAP-ACVIP 2023 Immunisation Schedule",
    keywords: ["iap schedule", "immunisation", "vaccine", "acvip 2023", "dtap", "ipv", "pcv", "rotavirus", "mmr", "varicella", "hpv", "typhoid tcv"],
    description: "Complete IAP-ACVIP 2023 schedule from birth to 18 yr. HPV for boys new 2023",
  },
  {
    id: "imm-uip", tab: "immunisation", tabLabel: "Immunisation",
    section: "NIP/UIP Schedule", label: "National Immunisation Programme (NIP/UIP) — GoI",
    keywords: ["uip", "nip", "government schedule", "bcg", "opv", "hbv", "pentavalent", "fipv", "mr", "je", "vitamin a", "td", "free vaccine"],
    description: "GoI/NHM free vaccination: BCG, OPV, Pentavalent, fIPV, Rotavirus, PCV, MR, JE, Td",
  },
  {
    id: "imm-hpv", tab: "immunisation", tabLabel: "Immunisation",
    section: "IAP Schedule", label: "HPV Vaccine — Girls & Boys (ACVIP 2023 NEW)",
    keywords: ["hpv", "human papillomavirus", "gardasil", "9vhpv", "girls", "boys", "9-14 years", "2 dose", "cervical cancer", "acvip 2023"],
    description: "9–14 yr girls AND boys: 2-dose schedule (0 and 6 months). 9vHPV preferred. NEW 2023",
  },
  {
    id: "imm-typhoid-tcv", tab: "immunisation", tabLabel: "Immunisation",
    section: "IAP Schedule", label: "Typhoid Conjugate Vaccine (TCV)",
    keywords: ["typhoid", "tcv", "typbar", "typhibev", "conjugate", "9 months", "enteric fever", "salmonella"],
    description: "Single dose IM from 9 months. TCV superior to Vi-PS. Booster optional at 2 yr",
  },
  {
    id: "imm-rabies-pep", tab: "immunisation", tabLabel: "Immunisation",
    section: "Special Vaccines", label: "Rabies PEP — Post-Exposure Prophylaxis",
    keywords: ["rabies pep", "post exposure prophylaxis", "rig", "rabies immunoglobulin", "animal bite", "5 dose essen", "thai red cross", "id intradermal"],
    description: "PCEC/PVRV: 5-dose Essen IM or 4-visit Thai Red Cross ID. RIG 20 IU/kg wound infiltration D0",
  },
  {
    id: "imm-catch-up", tab: "immunisation", tabLabel: "Immunisation",
    section: "Catch-up", label: "Catch-Up Vaccination Principles",
    keywords: ["catch up vaccine", "missed vaccine", "delayed vaccine", "never restart", "minimum interval", "same visit", "partial immunisation"],
    description: "Never restart a series. Give all due vaccines same visit. Respect minimum intervals",
  },
  {
    id: "imm-nnf-sepsis", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "NNF — Neonatal Sepsis Guidelines",
    keywords: ["nnf", "neonatal sepsis", "eos", "los", "early onset sepsis", "ampicillin gentamicin", "pip tazo", "blood culture"],
    description: "EOS: Ampicillin + Gentamicin. LONS: Pip-Tazo or Clox + Amikacin. Culture before antibiotics",
  },
  {
    id: "imm-nnf-rop", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "NNF — ROP Screening (Retinopathy of Prematurity)",
    keywords: ["rop", "retinopathy prematurity", "screening", "1750 g", "34 weeks", "laser", "anti vegf", "type 1 rop"],
    description: "Screen ≤1750 g or ≤34 wk. First exam: 4 weeks after birth or 32 weeks PMA",
  },
  {
    id: "imm-ntep", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "NTEP — Paediatric TB Guidelines 2022",
    keywords: ["tb", "tuberculosis", "ntep", "rntcp", "isoniazid", "rifampicin", "pyrazinamide", "fdc", "akurit", "nikshay", "ltbi", "mantoux", "mdr tb"],
    description: "2HRZE/4HR with weight-based FDC. LTBI: INH 10 mg/kg × 6 months. NIKSHAY mandatory",
  },
  {
    id: "imm-nvbdcp-malaria", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "NVBDCP — Malaria Guidelines 2023",
    keywords: ["malaria", "nvbdcp", "plasmodium vivax", "plasmodium falciparum", "artemether lumefantrine", "chloroquine", "artesunate iv", "primaquine", "g6pd"],
    description: "P. vivax: Chloroquine + Primaquine 14d. P. falciparum: AL/Coartem. Severe: IV Artesunate",
  },
  {
    id: "imm-nvbdcp-dengue", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "NVBDCP — Dengue Guidelines 2021",
    keywords: ["dengue", "nvbdcp", "ns1", "igm dengue", "group b dengue", "dengue platelet", "warning signs"],
    description: "Group A/B/C fluid management. Platelets only <10,000 or active bleeding. No NSAIDs",
  },
  {
    id: "imm-sam", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "SAM — Severe Acute Malnutrition Management",
    keywords: ["sam", "severe acute malnutrition", "muac", "rutf", "plumpy nut", "f-75", "f-100", "hypoglycaemia sam", "avoid bolus sam", "cmam"],
    description: "SAM: MUAC <11.5 cm. Avoid IV bolus. F-75→F-100. Glucose q2–3h. Amoxicillin prophylaxis",
  },
  {
    id: "imm-ams", tab: "immunisation", tabLabel: "Immunisation",
    section: "National Guidelines", label: "NCDC Antimicrobial Stewardship (AWaRe India 2023)",
    keywords: ["antimicrobial stewardship", "aware", "access watch reserve", "esbl", "de-escalate", "carbapenem", "colistin", "last resort"],
    description: "Access first-line · Watch: restricted · Reserve: XDR/PDR only. De-escalate 48–72 hr",
  },

  // ─── CO-PILOT ──────────────────────────────────────────────────────────────
  {
    id: "copilot-main", tab: "copilot", tabLabel: "Co-Pilot",
    section: "AI Assistant", label: "Co-Pilot — AI Clinical Assistant",
    keywords: ["copilot", "ai", "assistant", "clinical support", "ask", "chat", "question"],
    description: "AI-powered clinical assistant for paediatric emergency queries",
  },
];
